/* ============================================================
   Omana Mobile Checkout — Tickets → Stay → Guests → Review
   Reads product data injected by omana-mobile-checkout.liquid,
   and on checkout drives the store's own cart logic:
     window.theme.cart.store.add(items)  → service fee auto-applies
   then redirects to Shopify checkout.

   >>> VERIFY ON PREVIEW (buildCartItems): the exact line-item
   property schema + quantity semantics must match a real cart
   produced by the current flow. Everything to tune lives in
   buildCartItems() — centralised on purpose.
   ============================================================ */
(function () {
  var root = document.getElementById('omana-checkout');
  if (!root) return;
  var DATA;
  try { DATA = JSON.parse(document.getElementById('omana-checkout-data').textContent); }
  catch (e) {
    var raw = (document.getElementById('omana-checkout-data') || {}).textContent || '';
    console.error('[Omana checkout] product-data JSON failed to parse:', e);
    console.error('[Omana checkout] raw payload was:\n', raw);
    root.removeAttribute('data-loading');
    root.innerHTML = '<p style="padding:40px 24px;text-align:center;color:#8f8b7d;font-family:inherit">Checkout couldn’t load its product data. (See console for details.)</p>';
    return;
  }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- flow mode ----------------------------------------------------
     One engine, three flows, chosen by the section's data blob:
       full    → Tickets → Stay → Guests → Review   (default)
       tickets → Tickets → Guests → Review          (ticket-only page)
       stay    → Stay → Guests → Review             (accommodation-only page)
     Steps are driven by TYPES[] so nothing else is hard-coded to an index. */
  var MODE = (DATA.mode === 'tickets' || DATA.mode === 'stay' || DATA.mode === 'shuttle' || DATA.mode === 'wellness') ? DATA.mode : 'full';
  var STAY_VARIANT = (DATA.stayVariant === 'incl') ? 'incl' : 'excl'; // which accommodation variant to book
  var STAY_GUESTS = (DATA.stayGuestStep === false) ? false : true;     // stay-only: collect per-guest details?
  var COMMUNITY_CENTS = Number(DATA.communityTicketCents) || 22200;    // SUNRISE community ticket price (default €222)
  // Which codes are COMMUNITY-TICKET codes (reprice the ticket to COMMUNITY_CENTS + show the SUNRISE
  // banner). Only SUNRISE by default. Free-camping codes (GREECE*/CARAVAN*) also carry a companion but
  // must NOT reprice the ticket — so they are deliberately NOT in this list. Configurable via
  // DATA.communityCodes (e.g. "SUNRISE|EARLYCOMMUNITY").
  var COMMUNITY_KEYS = String(DATA.communityCodes || 'SUNRISE').toUpperCase().split(/[|,;]/).map(function (s) { return s.trim(); }).filter(Boolean);
  var MAXQ = (Number(DATA.maxGuests) > 0) ? Number(DATA.maxGuests) : 20; // max tickets/guests per order (e.g. 1 for volunteer)
  // Volunteer-style "free camping": own tent/caravan shown FREE, priced 0, and an auto-discount
  // (e.g. volunteer100) applied at checkout so they're actually free. All default off → other flows unchanged.
  var FREE_STAY = DATA.freeAccommodation === true;
  var FREE_STAY_LABEL = (DATA.freeStayLabel || 'included').toString();
  var AUTO_DISCOUNT = (DATA.autoDiscount || '').toString().trim();
  // Free camping pitch: listed promo codes auto-add ONE bring-your-own pitch to a TICKET-ONLY order
  // (zeroed by that code's companion discount, e.g. LOCALCAMPING100). Never fires outside the ticket-only flow.
  var FREE_PITCH = (Array.isArray(DATA.freePitch) ? DATA.freePitch : []).map(function (e) {
    return { variantId: Number(e && e.variantId) || 0, title: ((e && e.title) || 'Camping').toString(),
             codes: String((e && e.codes) || '').toUpperCase().split(/[|,;]/).map(function (s) { return s.trim(); }).filter(Boolean) };
  }).filter(function (e) { return e.variantId && e.codes.length; });
  var TYPES = MODE === 'tickets' ? ['tickets', 'guests', 'review']
            : MODE === 'stay' ? (STAY_GUESTS ? ['stay', 'guests', 'review'] : ['stay', 'review'])
            : MODE === 'shuttle' ? ['shuttle', 'guests', 'review']
            : MODE === 'wellness' ? ['wellness', 'guests', 'review']
            : ['tickets', 'stay', 'guests', 'review'];
  var HAS = { tickets: TYPES.indexOf('tickets') > -1, stay: TYPES.indexOf('stay') > -1, guests: TYPES.indexOf('guests') > -1, wellness: TYPES.indexOf('wellness') > -1 };
  var TYPE_TTL = { tickets: 'Get tickets', stay: 'Accommodation', guests: 'Guest details', review: 'Review', shuttle: 'Airport shuttle', wellness: 'Wellness & Workshops' };
  var TYPE_LBL = { tickets: 'Tickets', stay: 'Stay', guests: 'Guests', review: 'Review', shuttle: 'Shuttle', wellness: 'Sessions' };
  // Names+email-only guest step (no DOB / gender / 18+ check): shuttle passengers and wellness bookers.
  var NAMES_ONLY = MODE === 'shuttle' || MODE === 'wellness';
  var MAX_PER_SLOT = (Number(DATA.maxPerSlot) > 0) ? Number(DATA.maxPerSlot) : 10; // wellness: max seats of one slot per order
  // Airline-style seat counter on shuttle departures: ≥ SEAT_LOW "Available" · below it "Only N seats left" · below SEAT_HOT "Almost sold out".
  var SEAT_LOW = (Number(DATA.seatLow) > 0) ? Number(DATA.seatLow) : 13;
  var SEAT_HOT = (Number(DATA.seatHot) > 0) ? Number(DATA.seatHot) : 6;
  function guestsTitle() { return MODE === 'shuttle' ? 'Passengers' : MODE === 'wellness' ? 'Your details' : TYPE_TTL.guests; }
  function guestsLabel() { return MODE === 'shuttle' ? 'Passengers' : MODE === 'wellness' ? 'Details' : TYPE_LBL.guests; }

  /* ---------- wellness · slot parsing (a variant title IS the time slot) ----------
     "Wed 30 Sep · 20:00–20:20" or "Sat 3 Oct · 14:00–15:00 (60 min)". Integer minutes, no Date objects. */
  var SLOT_RE = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun)\s+(\d{1,2})\s+([A-Z][a-z]{2})\s*[·•|\-–]\s*(\d{1,2}):(\d{2})\s*[–—\-]\s*(\d{1,2}):(\d{2})(?:\s*\((\d+)\s*min\))?\s*$/;
  var MON = { Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12' };
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function hhmm(m) { return pad2(Math.floor(m / 60)) + ':' + pad2(m % 60); }
  function parseSlot(title, sku) {
    var m = SLOT_RE.exec(String(title || '').trim()); if (!m || !MON[m[3]]) return null;
    var year = String(DATA.festivalStart || '2026-09-30').slice(0, 4);
    var startMin = (+m[4]) * 60 + (+m[5]), endMin = (+m[6]) * 60 + (+m[7]);
    var dur = m[8] ? +m[8] : (endMin - startMin);
    if (!(dur > 0)) { var sm = /-\d{4}-(\d{2,3})$/.exec(String(sku || '')); if (sm) dur = +sm[1]; }
    return { dow: m[1], day: +m[2], mon: m[3], dateISO: year + '-' + MON[m[3]] + '-' + pad2(+m[2]),
             startMin: startMin, endMin: endMin, durMin: dur, timeLabel: hhmm(startMin) + '–' + hhmm(endMin) };
  }
  // The festival's day strip: festivalStart + N days, UTC arithmetic (no DST / timezone drift).
  var DAYS_CACHE = null;
  function days() {
    if (DAYS_CACHE) return DAYS_CACHE;
    var p = String(DATA.festivalStart || '2026-09-30').split('-'), n = Number(DATA.festivalDays) > 0 ? Number(DATA.festivalDays) : 7;
    var base = Date.UTC(+p[0], (+p[1]) - 1, +p[2]), DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], out = [];
    for (var i = 0; i < n; i++) { var d = new Date(base + i * 86400000);
      out.push({ iso: d.getUTCFullYear() + '-' + pad2(d.getUTCMonth() + 1) + '-' + pad2(d.getUTCDate()), dow: DOW[d.getUTCDay()], d: d.getUTCDate(), mon: MN[d.getUTCMonth()] }); }
    DAYS_CACHE = out; return out;
  }
  // "20 min · 1:1 · Moon Womb Tent · For people with a womb" → duration / kind / location / eligibility chips.
  function parseMeta(meta) {
    var out = { duration: '', kind: '', groupCap: 0, location: '', eligibility: '' };
    String(meta || '').split(/\s*[·•|]\s*/).forEach(function (t) {
      t = t.trim(); if (!t) return; var gm;
      if (/^\d+(?:\s*(?:or|to|-|–)\s*\d+)?\s*min$/i.test(t)) out.duration = t;
      else if (/^1\s*:\s*1$/.test(t)) out.kind = '1to1';
      else if ((gm = /^up to (\d+)/i.exec(t))) { out.kind = 'group'; out.groupCap = +gm[1]; }
      else if (/material fee/i.test(t)) out.kind = 'workshop';
      else if (/^for /i.test(t)) out.eligibility = t;
      else if (!out.location) out.location = t;
    });
    return out;
  }
  function typeAt(i) { return TYPES[i]; }
  function ctaFor(i) { return i >= TYPES.length - 1 ? 'Secure checkout' : (TYPES[i + 1] === 'review' ? 'Review order' : 'Next'); }

  /* ---------- money (Shopify prices are in cents) ----------
     Formats through the store's own money_format (works for any currency/locale
     the shop is configured for). Decimals are shown only when the amount has
     them — €259 / €1.029 / −€25,90 — so whole prices stay clean everywhere. */
  var MONEY_FMT = String(DATA.moneyFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
  function money(cents) {
    var c = Math.round(Number(cents) || 0), neg = c < 0; c = Math.abs(c);
    var whole = c % 100 === 0;
    function amt(sep, dsep, noDec) {
      var p = (c / 100).toFixed(noDec || whole ? 0 : 2).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (p[1] ? dsep + p[1] : '');
    }
    var out = MONEY_FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      switch (k) {
        case 'amount': return amt(',', '.');
        case 'amount_no_decimals': return amt(',', '.', true);
        case 'amount_no_decimals_with_comma_separator': return amt('.', ',', true);
        case 'amount_with_apostrophe_separator': return amt("'", '.');
        case 'amount_with_space_separator': return amt(' ', ',');
        case 'amount_no_decimals_with_space_separator': return amt(' ', ',', true);
        case 'amount_with_period_and_space_separator': return amt(' ', '.');
        default: return amt('.', ','); // amount_with_comma_separator
      }
    });
    return (neg ? '−' : '') + out.trim();
  }

  /* ---------- build catalog from real product data ---------- */
  function cleanAmenities(tags) {
    if (!tags || !tags.length) return [];
    var drop = { 'on-site': 1, 'off-site': 1 };
    var out = [];
    tags.forEach(function (t) {
      var k = String(t).trim();
      if (!k || drop[k.toLowerCase()] || k.indexOf('_') === 0) return;
      out.push(k.charAt(0).toUpperCase() + k.slice(1));
    });
    return out.slice(0, 6);
  }
  function pickStayVariant(p) {
    // Full/ticket flows always have a ticket in the order → book the "exkl. Ticket" variant.
    // Accommodation-only can be set to book the "inkl. Ticket" bundle instead (STAY_VARIANT).
    var wantExcl = STAY_VARIANT !== 'incl';
    function match(v) { return wantExcl ? v.exclTicket : !v.exclTicket; }
    return p.variants.find(function (v) { return match(v) && v.available; })
        || p.variants.find(function (v) { return match(v); })
        || p.variants.find(function (v) { return v.available; })
        || p.variants[0] || null;
  }
  // Occupancy is encoded in the variant's option1 (e.g. "2 People") — same rule the live site uses.
  // Per-person = the stay's price split across the number of GUESTS selected (CART.qty),
  // not the unit's capacity. Returns 0 for a single guest (would just equal the total).
  function perPersonCents(cents) { return CART.qty > 1 ? Math.round(Number(cents) / CART.qty) : 0; }

  var SHOP = {
    serviceFeeCents: DATA.serviceFee || 2000,
    ticketTitle: (DATA.ticket && DATA.ticket.title) || 'Festival Ticket',
    ticketImage: (DATA.ticket && DATA.ticket.image) || '',
    tickets: ((DATA.ticket && DATA.ticket.variants) || []).map(function (v) {
      return { id: v.id, title: v.title, priceCents: v.price, status: v.status || (v.available ? 'live' : 'sold'),
               sub: v.sub || '', badge: v.badge || '', badgeText: v.badgeText || '', phaseLabel: v.phaseLabel || '' };
    }),
    stay: [{ id: 'none', cat: null, title: 'No accommodation', priceCents: 0 }].concat(
      (DATA.accommodation || []).map(function (p) {
        var vr = pickStayVariant(p);
        var feats = cleanAmenities(p.amenities);
        if (!feats.length) {
          if (p.sleeps) feats.push(sleepsLabel(p.sleeps));
          if (p.rooms) feats.push(p.rooms + ' room' + (p.rooms == 1 ? '' : 's'));
        }
        return {
          id: String(p.id), handle: p.handle, cat: p.cat, title: p.title, multi: !!p.multi,
          desc: p.desc || '', lead: p.infotext || '', long: p.descFull || p.desc || '', img: p.img || '',
          images: (p.images && p.images.length) ? p.images : (p.img ? [p.img] : []),
          sleeps: p.sleeps || '', rooms: p.rooms || '',
          walk: p.cat === 'onsite' ? 'On the festival grounds' : 'Off-site · shuttle available',
          features: feats,
          priceCents: vr ? vr.price : 0,
          variantId: vr ? vr.id : null,
          available: p.variants.some(function (v) { return v.available; })
        };
      })
    ),
    shuttle: (function () {
      // One product per direction; its variants are the departure TIMES.
      function opts(prod) {
        var list = [{ id: 'none', title: 'No shuttle', priceCents: 0, variantId: null, available: true }];
        ((prod && prod.variants) || []).forEach(function (v) {
          // A real seat count only when the section emits it (inv + managed); older blobs keep plain available / sold-out.
          var hasCount = typeof v.inv === 'number' && v.managed !== undefined;
          var unlimited = hasCount ? (!v.managed || v.policy === 'continue') : true;
          var left = (hasCount && !unlimited) ? Math.max(0, v.inv) : Infinity;
          list.push({ id: String(v.id), title: v.title, priceCents: v.price, variantId: v.id, available: !!v.available && left > 0, left: left, hasCount: hasCount && !unlimited });
        });
        return list;
      }
      return {
        in: opts(DATA.shuttleTo), out: opts(DATA.shuttleFrom), // in = to festival (arrival), out = from festival (departure)
        inTitle: (DATA.shuttleTo && DATA.shuttleTo.title) || 'SKG Airport → Festival',
        outTitle: (DATA.shuttleFrom && DATA.shuttleFrom.title) || 'Festival → SKG Airport'
      };
    })(),
    // Wellness: bookable sessions / workshops. Each product = a session; its variants = the time slots.
    sessions: (DATA.sessions || []).map(function (p) {
      var meta = (p.meta || '').toString().trim();
      if (!meta) { var sm = /<strong>([\s\S]*?)<\/strong>/i.exec(p.descFull || ''); if (sm) meta = sm[1].replace(/<[^>]+>/g, '').trim(); }
      var pm = parseMeta(meta), vars = p.variants || [];
      var slotless = p.optionName === 'Title' || (vars.length === 1 && /^default title$/i.test(vars[0].title || ''));
      var slots = vars.map(function (v) {
        var ps = slotless ? null : parseSlot(v.title, v.sku);
        if (!slotless && !ps) console.warn('[Omana checkout] unparseable slot title:', p.handle, v.title);
        var unlimited = !v.managed || v.policy === 'continue';
        var left = unlimited ? Infinity : Math.max(0, Number(v.inv) || 0);
        return { id: String(v.id), variantId: v.id, title: v.title, sku: v.sku || '', priceCents: Number(v.price) || 0,
                 available: !!v.available && (unlimited || left > 0), left: left, unlimited: unlimited,
                 dateISO: ps ? ps.dateISO : null, startMin: ps ? ps.startMin : 0, endMin: ps ? ps.endMin : 0,
                 durMin: ps ? ps.durMin : 0, timeLabel: ps ? ps.timeLabel : '' };
      });
      var byDay = {};
      slots.forEach(function (s) { if (s.dateISO) (byDay[s.dateISO] = byDay[s.dateISO] || []).push(s); });
      Object.keys(byDay).forEach(function (k) { byDay[k].sort(function (a, b) { return a.startMin - b.startMin; }); });
      var kind = slotless ? 'anytime' : (pm.kind || (slots.some(function (s) { return s.left > 1; }) ? 'group' : '1to1'));
      var prices = slots.map(function (s) { return s.priceCents; });
      return { id: String(p.id), handle: p.handle, title: p.title, desc: p.desc || '', long: p.descFull || '',
               img: p.img || '', images: (p.images && p.images.length) ? p.images : (p.img ? [p.img] : []),
               meta: meta, duration: pm.duration, location: pm.location, eligibility: pm.eligibility,
               kind: kind, groupCap: pm.groupCap || 0, priceFrom: prices.length ? Math.min.apply(null, prices) : 0,
               slots: slots, byDay: byDay, other: slots.filter(function (s) { return !s.dateISO && !slotless; }) };
    }),
    // Guests must be 18 on festival start day → latest allowed birthdate.
    dobMax: (function () {
      var p = String(DATA.festivalStart || '2026-09-30').split('-');
      return (parseInt(p[0], 10) - 18) + '-' + p[1] + '-' + p[2];
    })(),
    // Lower bound (~100 yrs) so the native picker can't drift to year 0 and typed years stay sane.
    dobMin: (parseInt(String(DATA.festivalStart || '2026-09-30').split('-')[0], 10) - 100) + '-01-01'
  };

  /* ---------- cart state ---------- */
  var firstLive = SHOP.tickets.find(function (t) { return t.status === 'live'; });
  var CART = { variant: firstLive ? firstLive.id : (SHOP.tickets[0] || {}).id, qty: 1, stay: 'none', stayCat: 'onsite', stayQty: 1, discount: null, freePitch: null, shIn: 'none', shOut: 'none', notes: '', guests: [], sessions: [] };
  var FSTEP = 0, openGuest = 0, pickerCtx = null, stayDetailId = null, wlOpen = null, wlDay = {}; // wlOpen/wlDay: wellness session sheet
  var cartData = null;      // last real Shopify cart (from cart.js) once committed at Review
  var committing = false;   // true while (re)building the cart in Shopify
  var commitPending = false;// a change arrived mid-commit → run once more when done
  var phasesOpen = false;   // Step 1: full phase timeline expanded vs compact summary
  var galTimer = null;      // stay-detail gallery auto-advance timer

  /* ---------- helpers ---------- */
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 12l5 5L19 7"/></svg>';
  var INFO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9.5"/><path d="M12 8h.01M12 11.5V16" stroke-linecap="round"/></svg>';
  var IC_TICKET = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7.5A1.5 1.5 0 015.5 6h13A1.5 1.5 0 0120 7.5v2a2.5 2.5 0 000 5v2a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 16.5v-2a2.5 2.5 0 000-5z"/><path d="M14.5 6v12" stroke-dasharray="2.6 2.6"/></svg>';
  var IC_VAN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M2.5 7.5h11.5v9H2.5zM14 10.5h4.2l3.3 3.2v2.8H14z"/><circle cx="6.6" cy="17.6" r="1.7"/><circle cx="17.6" cy="17.6" r="1.7"/></svg>';
  function byId(id) { return document.getElementById(id); }
  function variant() { return SHOP.tickets.find(function (v) { return v.id === CART.variant; }) || SHOP.tickets[0] || { priceCents: 0, title: '' }; }
  function stayOpt() { return SHOP.stay.find(function (s) { return s.id === CART.stay; }) || SHOP.stay[0]; }
  function stayUnits(s) { return (s && s.multi) ? CART.stayQty : 1; }        // "own tent/caravan" = N units
  function stayMax() { return Math.max(1, CART.qty); }                       // never more tents/caravans than guests
  // SUNRISE community mode: true when a code that brings a companion (SUNRISECAMP) is on the
  // cart — from the ?code= link or entered. Only PREVIEW it before Review; at Review the real
  // Shopify cart takes over, so the price the guest actually pays is always the source of truth.
  function communityCodeOn() { return !!CART.discount && companionsFor(CART.discount).length > 0; } // any companion code (free camping) is on the cart
  function communityActive() { return TYPES[FSTEP] !== 'review' && communityCodeOn(); }             // preview free-camping before Review
  // A COMMUNITY-TICKET code (SUNRISE) additionally reprices the ticket + shows the SUNRISE banner.
  // Caravan/Greece free-camping codes have a companion but are NOT community-ticket codes.
  function communityTicketOn() { var d = CART.discount; return !!d && COMMUNITY_KEYS.some(function (k) { return d.indexOf(k) > -1; }); }
  function communityTicketActive() { return TYPES[FSTEP] !== 'review' && communityTicketOn(); }     // preview ticket reprice before Review
  function stayFree() { return communityActive() || FREE_STAY; }   // own tent/caravan shown free (pre-review)
  function stayFreeC() { return communityCodeOn() || FREE_STAY; }  // own tent/caravan free at Review / committed
  function communityBanner() {
    if (!communityTicketActive()) return '';
    var price = COMMUNITY_CENTS > 0 ? (money(COMMUNITY_CENTS, 0) + ' per guest · ') : '';
    return '<div class="omc-commbar"><span class="cb-badge">SUNRISE</span><span class="cb-txt"><b>Community ticket</b> — ' + price + 'own tent or caravan included. Your code is applied.</span></div>';
  }
  function stayTotalCents(s) { return (s && s.id !== 'none') ? s.priceCents * stayUnits(s) : 0; }
  // Sleeping capacity from the sleeps/capacity metafield (0 = no fixed capacity, e.g. own tent/caravan).
  function capacityOf(s) { var n = parseInt(s && s.sleeps, 10); return isNaN(n) ? 0 : n; }
  // A stay fits the group if it sleeps at least as many as the guests selected (own/uncapped always fit).
  function fitsGroup(s) { if (s && s.multi) return true; var cap = capacityOf(s); return cap === 0 || cap >= CART.qty; }
  // Unit noun for multi ("own") stays, derived from the product title.
  function stayUnitWord(s) {
    var t = ((s && s.title) || '').toLowerCase();
    if (t.indexOf('caravan') > -1) return { one: 'caravan', many: 'caravans', ask: 'How many caravans?', hint: 'One spot per caravan' };
    if (t.indexOf('tent') > -1) return { one: 'pitch', many: 'pitches', ask: 'How many pitches?', hint: 'One tent per pitch' };
    return { one: 'unit', many: 'units', ask: 'How many units?', hint: '' };
  }
  // Seat-availability pill (airline style) — only for departures whose section emitted a real count.
  function seatBadge(o) {
    if (!o || !o.hasCount) return '';
    if (!o.available || o.left <= 0) return '<span class="seat seat-sold">Sold out</span>';
    if (o.left >= SEAT_LOW) return '<span class="seat seat-ok">Available</span>';
    if (o.left >= SEAT_HOT) return '<span class="seat seat-low">Only ' + o.left + ' seat' + (o.left === 1 ? '' : 's') + ' left</span>';
    return '<span class="seat seat-hot">Almost sold out</span>';
  }
  function seatsMsg(o) { return 'Only ' + o.left + ' seat' + (o.left === 1 ? '' : 's') + ' left on ' + o.title + ' — pick another departure or fewer passengers'; }
  function shOpt(dir, id) { return SHOP.shuttle[dir === 'in' ? 'in' : 'out'].find(function (o) { return o.id === id; }) || SHOP.shuttle[dir === 'in' ? 'in' : 'out'][0]; }
  function syncGuests() { while (CART.guests.length < CART.qty) CART.guests.push({ first: '', last: '', email: '', dob: '', gender: '', shuttleIn: 'none', shuttleOut: 'none' }); CART.guests.length = CART.qty; }
  function dobTooYoung(g) { return !!g.dob && g.dob > SHOP.dobMax; } // ISO strings compare safely
  function emailValid(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || '').trim()); }
  function guestComplete(g) { if (NAMES_ONLY) return !!(g.first && g.last && emailValid(g.email)); return g.first && g.last && emailValid(g.email) && g.dob && !dobTooYoung(g) && g.gender; }
  // A live ticket is actually selectable/selected — false in the coming-soon / all-sold-out state,
  // where CART.variant falls back to a non-live phase (nothing is really in the order).
  function ticketChosen() { return HAS.tickets && !!(variant() && variant().status === 'live'); }
  // The €20/guest booking fee rides on a ticket OR a "real" accommodation booking. Bring-your-own
  // pitches (Own Tent / Own Caravan — the cheap `multi` stays) don't trigger it on their own, and
  // shuttle-only orders have neither a ticket nor a stay → no fee.
  function feeApplies() { return SHOP.serviceFeeCents > 0 && (ticketChosen() || (stayOpt() && stayOpt().id !== 'none' && !stayOpt().multi)); }
  function computeTotals(comm) {
    var v = variant(), q = CART.qty, st = stayOpt();
    var ticketUnit = (comm && communityTicketOn() && COMMUNITY_CENTS > 0) ? COMMUNITY_CENTS : v.priceCents; // community ticket price (SUNRISE only)
    var ticket = ticketChosen() ? ticketUnit * q : 0;
    var stayC = stayTotalCents(st);  // unit price × pitches (own tent) or × 1 (single unit)
    if ((comm || FREE_STAY) && st && st.multi) stayC = 0; // SUNRISECAMP / volunteer: own tent / own caravan free
    var fee = feeApplies() ? SHOP.serviceFeeCents * q : 0; // per-guest booking fee — only with a product
    var shuttle = 0;
    if (MODE === 'shuttle') { shuttle = (shOpt('in', CART.shIn).priceCents + shOpt('out', CART.shOut).priceCents) * q; }
    else CART.guests.forEach(function (g) { shuttle += shOpt('in', g.shuttleIn).priceCents + shOpt('out', g.shuttleOut).priceCents; });
    var sessions = MODE === 'wellness' ? sessionCents() : 0;
    return { ticketCents: ticket, stayCents: stayC, feeCents: fee, shuttleCents: shuttle, sessionCents: sessions, totalCents: ticket + stayC + fee + shuttle + sessions, q: q, community: comm, ticketUnitCents: ticketUnit };
  }
  function totals() { return computeTotals(communityActive()); }
  // Preview discount = raw price − community price (mirrors SUNRISE −€ off ticket + SUNRISECAMP free own-camping).
  function communityDiscountCents() { return communityCodeOn() ? Math.max(0, computeTotals(false).totalCents - computeTotals(true).totalCents) : 0; }
  // Final price at Review: the REAL Shopify cart when we have it, else the previewed discounted total.
  function finalTotalCents() {
    if (cartData && (cartData.total_discount || 0) > 0) return cartData.total_price;      // real discount wins
    if (communityCodeOn()) return computeTotals(false).totalCents - communityDiscountCents(); // else preview it
    return cartData ? cartData.total_price : computeTotals(false).totalCents;
  }

  var toastT;
  function toast(m) { var el = byId('omc-toast'); el.textContent = m; el.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('show'); }, 2000); }

  /* ---------- discount companions ----------------------------------------
     One guest-facing code can silently bring combinable partner discounts
     (e.g. SUNRISE = 15% tickets + SUNRISECAMP = 100% own tent/caravan).
     Configured via the section's "companion_codes" setting:
       "SUNRISE=SUNRISECAMP; OTHER=A|B"
     Both discounts must be set to combine with product discounts in Shopify. */
  var COMPANIONS = {};
  String(DATA.companionCodes || '').split(';').forEach(function (pair) {
    var kv = pair.split('=');
    var key = (kv[0] || '').trim().toUpperCase();
    if (!key || !kv[1]) return;
    COMPANIONS[key] = kv[1].split('|').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
  });
  // Companion codes for a given code — a configured key matches when the guest's code
  // CONTAINS it (case-insensitive), so ANY code containing e.g. "SUNRISE" pulls in
  // SUNRISECAMP. De-duped; never returns the entered code itself.
  function companionsFor(code) {
    var up = String(code || '').toUpperCase(), out = [];
    Object.keys(COMPANIONS).forEach(function (key) {
      if (up.indexOf(key) === -1) return;
      COMPANIONS[key].forEach(function (c) { if (c && c !== up && out.indexOf(c) === -1) out.push(c); });
    });
    return out;
  }

  /* ---------- step machine (index-agnostic: everything keys off TYPES[]) ---------- */
  var fromPop = false; // true while navigating because of a browser back/forward
  function goStep(n) {
    if (n < 0 || n >= TYPES.length) return;
    if (!fromPop && n > 0 && n !== FSTEP) history.pushState({ omc: n }, '', '#' + TYPES[n]);
    FSTEP = n; syncGuests();
    var type = TYPES[n];
    root.setAttribute('data-step', type); // drives desktop two-pane vs single-column (review)
    root.querySelectorAll('.fstep').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-type') === type); });
    root.querySelectorAll('#omc-steps .stp').forEach(function (el, i) { el.classList.toggle('cur', i === n); el.classList.toggle('done', i < n); });
    root.querySelectorAll('#omc-steps .bar').forEach(function (el, i) { el.classList.toggle('on', i < n); });
    if (type === 'tickets') renderTickets();
    if (type === 'stay') renderStay();
    if (type === 'shuttle') renderShuttle();
    if (type === 'wellness') renderWellness();
    if (type === 'guests') renderGuests();
    if (type === 'review') renderReview();
    var wlo = byId('omc-wl-overlay'); if (wlo) { wlo.classList.remove('show'); wlOpen = null; } // a session sheet never survives a step change
    updateFoot();
    byId('omc-body').scrollTop = 0;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function flowNext() {
    var type = TYPES[FSTEP];
    if (type === 'tickets' && (!variant() || variant().status !== 'live')) { toast('Please select an available ticket'); return; }
    if (type === 'stay' && MODE === 'stay' && (!stayOpt() || stayOpt().id === 'none')) { toast('Please choose a place to stay'); return; }
    if (type === 'shuttle' && CART.shIn === 'none' && CART.shOut === 'none') { toast('Pick at least one transfer'); return; }
    if (type === 'wellness' && !CART.sessions.length) { toast('Pick at least one session'); return; }
    if (type === 'guests') {
      var bad = CART.guests.findIndex(function (g) { return !guestComplete(g); });
      if (bad > -1) { openGuest = bad; renderGuests(); toast(MODE === 'wellness' ? 'Please complete your details' : 'Please complete ' + (MODE === 'shuttle' ? 'passenger ' : 'guest ') + (bad + 1) + "'s details"); return; }
    }
    if (type === 'review') { checkout(); return; }
    goStep(FSTEP + 1);
  }
  // Returning from Shopify checkout (incl. the browser's back-forward cache) restores the page
  // with the "taking you to checkout" overlay still up — clear it and reset state so it can't loop.
  window.addEventListener('pageshow', function () {
    var ho = byId('omc-handoff'); if (ho) ho.classList.remove('show');
    committing = false;
    if (TYPES[FSTEP] === 'review') { renderTotals(); updateFoot(); }
  });
  // Browser back/forward walks the steps (mobile-native expectation).
  window.addEventListener('popstate', function (e) {
    var s = (e.state && typeof e.state.omc === 'number') ? e.state.omc : 0;
    if (s === FSTEP) return;
    fromPop = true; goStep(s); fromPop = false;
  });
  function flowBack() { if (FSTEP > 0) history.back(); else closeFlow(); }
  function closeFlow() { window.location.href = ROOT; } // ✕ = leave the flow entirely
  function updateFoot() {
    var onReview = TYPES[FSTEP] === 'review';
    // On Review: real cart total when we have it, else the previewed discounted total.
    var cents = onReview ? finalTotalCents() : totals().totalCents;
    byId('omc-foottot').textContent = committing && onReview ? '…' : money(cents);
    var fn = byId('omc-footfee');
    if (fn) fn.textContent = feeApplies() ? 'incl. ' + money(SHOP.serviceFeeCents) + ' booking fee per guest' : '';
    byId('omc-cta').textContent = ctaFor(FSTEP);
    byId('omc-ttl').textContent = TYPES[FSTEP] === 'guests' ? guestsTitle() : TYPE_TTL[TYPES[FSTEP]];
    renderSide();
  }
  // Desktop-only live order summary (right rail on steps 1–3; hidden on Review, which is itself the summary).
  function sideRow(title, meta, price) {
    return '<div class="sr"><div class="sr-t">' + title + (meta ? '<span>' + meta + '</span>' : '') + '</div><div class="sr-p">' + price + '</div></div>';
  }
  function renderSide() {
    var lines = byId('omc-side-lines'); if (!lines) return;
    var t = totals(), v = variant(), st = stayOpt(), rows = '';
    if (ticketChosen()) rows += sideRow(SHOP.ticketTitle + ' · ' + v.title, t.q + ' × ' + money(v.priceCents), money(t.ticketCents));
    if (st && st.id !== 'none') rows += sideRow(st.title + (st.multi ? ' × ' + CART.stayQty : ''), st.multi ? (CART.stayQty + ' ' + (CART.stayQty > 1 ? stayUnitWord(st).many : stayUnitWord(st).one) + ' · ' + money(st.priceCents) + ' each') : 'Whole week', money(t.stayCents));
    if (MODE === 'shuttle') {
      var siS = shOpt('in', CART.shIn), soS = shOpt('out', CART.shOut);
      if (siS.variantId) rows += sideRow(SHOP.shuttle.inTitle, siS.title + ' · ' + t.q + ' × ' + money(siS.priceCents), money(siS.priceCents * t.q));
      if (soS.variantId) rows += sideRow(SHOP.shuttle.outTitle, soS.title + ' · ' + t.q + ' × ' + money(soS.priceCents), money(soS.priceCents * t.q));
    } else if (t.shuttleCents) rows += sideRow('Airport shuttle', 'SKG transfers', money(t.shuttleCents));
    if (MODE === 'wellness') CART.sessions.forEach(function (l) { var s = sessionById(l.sessionId), sl = slotOf(s, l.slotId);
      rows += sideRow(l.productTitle, (l.dateISO ? fmtDay(l.dateISO) + ' · ' + (sl ? sl.timeLabel : '') : 'Anytime') + (l.qty > 1 ? ' · ' + l.qty + ' × ' + money(l.priceCents) : ''), money(l.priceCents * l.qty)); });
    if (feeApplies()) rows += sideRow('Service fee', money(SHOP.serviceFeeCents) + ' × ' + t.q, money(t.feeCents));
    lines.innerHTML = rows || '<div class="side-empty">Your selections appear here as you build your order.</div>';
    var onReview = TYPES[FSTEP] === 'review';
    var cents = onReview ? finalTotalCents() : t.totalCents;
    byId('omc-side-tot').innerHTML = '<span>Total</span><span>' + (committing && onReview ? '…' : money(cents)) + '</span>';
    var c = byId('omc-side-cta'); if (c) c.textContent = ctaFor(FSTEP);
  }

  /* ---------- STEP 1 · tickets ---------- */
  function badge(v) {
    var s = (v && typeof v === 'object') ? v.status : v;   // accepts a ticket object or a raw status string
    if (s === 'live') {
      var style = (v && v.badge) || DATA.phaseBadge || 'almost';
      if (style === 'none') return '';                     // per-ticket opt-out (e.g. weekend ticket)
      var cls = style === 'available' ? 'b-avail' : style === 'red' ? 'b-hot' : 'b-live';
      var txt = (v && v.badgeText) || DATA.phaseBadgeText || (style === 'available' ? 'Available' : 'Almost sold out');
      return '<span class="badge ' + cls + '">' + txt + '</span>';
    }
    return s === 'soon' ? '<span class="badge b-soon">Coming soon</span>' : '<span class="badge b-sold">Sold out</span>';
  }
  function qStepper() {
    return '<div class="qty" onclick="event.stopPropagation()">' +
      '<button ' + (CART.qty <= 1 ? 'disabled' : '') + ' onclick="OMC.qty(-1)">−</button>' +
      '<span class="n">' + CART.qty + '</span>' +
      '<button ' + (CART.qty >= MAXQ ? 'disabled' : '') + ' onclick="OMC.qty(1)">+</button></div>';
  }
  function renderTickets() {
    var live = SHOP.tickets.filter(function (v) { return v.status === 'live'; });
    var rest = SHOP.tickets.filter(function (v) { return v.status !== 'live'; });
    var soonList = SHOP.tickets.filter(function (v) { return v.status === 'soon'; });
    // Step subtitle reflects the state — nothing to "choose" until a ticket is live.
    var subEl = byId('omc-tksub');
    if (subEl && !live.length) subEl.textContent = soonList.length
      ? 'These tickets go on sale soon — here’s what’s coming.'
      : 'Tickets are currently sold out. Please check back soon.';
    if (!live.length && soonList.length) {
      // Coming-soon: show the upcoming tickets as clear, NON-selectable cards.
      byId('omc-ticketlist').innerHTML = soonList.map(function (v) {
        return '<div class="tkcard soon" aria-disabled="true">' +
          '<div class="tk-top"><div class="tk-info"><div class="tk-nm">' + v.title + '</div>' +
            (v.sub ? '<div class="tk-sub">' + v.sub + '</div>' : '') +
            '<span class="badge b-soon">Coming soon</span></div>' +
          '<div class="tk-rt"><div class="tk-pr">' + money(v.priceCents, 0) + '</div><div class="tk-pu">per guest</div></div></div>' +
          '</div>';
      }).join('');
    } else if (!live.length) {
      byId('omc-ticketlist').innerHTML = '<div class="tkcard" style="text-align:center;color:var(--ink-mute)">Tickets are currently sold out. Please check back soon.</div>';
    } else {
      byId('omc-ticketlist').innerHTML = communityBanner() + live.map(function (v) {
        var sel = v.id === CART.variant, multi = live.length > 1;
        var priceHTML = (communityTicketActive() && COMMUNITY_CENTS > 0)
          ? '<div class="tk-pr"><span class="tk-was">' + money(v.priceCents, 0) + '</span> ' + money(COMMUNITY_CENTS, 0) + '</div><div class="tk-pu">SUNRISE · per guest</div>'
          : '<div class="tk-pr">' + money(v.priceCents, 0) + '</div><div class="tk-pu">per guest</div>';
        return '<div class="tkcard' + (sel ? ' sel' : '') + (multi ? ' pick' : '') + '" role="radio" aria-checked="' + (sel ? 'true' : 'false') + '" onclick="OMC.pickTicket(\'' + v.id + '\')">' +
          '<div class="tk-top">' + (multi ? '<span class="tk-rad" aria-hidden="true"></span>' : '') + '<div class="tk-info"><div class="tk-nm">' + v.title + '</div>' + (v.sub ? '<div class="tk-sub">' + v.sub + '</div>' : '') + badge(v) + '</div>' +
          '<div class="tk-rt">' + priceHTML + '</div></div>' +
          (sel ? '<div class="tk-qrow"><div class="tk-ql">How many guests?<small>One pass per guest</small></div>' + qStepper() + '</div>' +
            '<div class="tk-fee"><span class="fi">' + INFO + '</span><span>A <b>' + money(SHOP.serviceFeeCents) + ' booking fee per guest</b> (incl. 19% VAT) is included in your total.</span></div>' : '') +
          '</div>';
      }).join('');
    }
    // Phase list — compact by default (past collapsed, future shown), expandable to full timeline.
    var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>';
    function phlRow(v) {
      var cls = v.status === 'live' ? 'cur' : (v.status === 'soon' ? 'soon' : 'sold');
      var labelled = v.status === 'live' && v.phaseLabel;   // custom timeline label already names the phase
      var nm = labelled ? v.phaseLabel : v.title;
      var cap = labelled ? ''
              : v.status === 'live' ? '<span class="phl-badge">Current phase</span>'
              : v.status === 'soon' ? '<span class="phl-cap">' + LOCK + ' Soon</span>'
              : '<span class="phl-cap">Sold out</span>';
      return '<div class="phl-row ' + cls + '"><i class="phl-dot"></i>' +
        '<div class="phl-b"><span class="phl-nm">' + nm + '</span>' + cap + '</div>' +
        '<span class="phl-pr">' + money(v.priceCents, 0) + '</span></div>';
    }
    var sold = SHOP.tickets.filter(function (v) { return v.status === 'sold'; });
    var soon = SHOP.tickets.filter(function (v) { return v.status === 'soon'; });
    var others = sold.length + soon.length;
    var urgency = (live.length === 1 && live[0]) ? '<div class="tk-cap">⚡ <span><b>' + live[0].title + '</b> is the current price — secure it before it\'s gone.</span></div>' : '';
    var out = '';
    if (others) {
      out += '<div class="ladder-h"><span class="lt">Ticket phases</span><span class="ln">prices rise each phase</span></div>';
      if (phasesOpen) {
        out += '<div class="phl">' + SHOP.tickets.map(phlRow).join('') + '</div>' +
          '<button class="phl-toggle" onclick="OMC.togglePhases()">Show fewer ▲</button>';
      } else {
        out += '<div class="phsum">';
        if (sold.length) {
          var minSold = Math.min.apply(null, sold.map(function (s) { return s.priceCents; }));
          out += '<button class="phsum-sold" onclick="OMC.togglePhases()"><span>' + sold.length + ' phase' + (sold.length > 1 ? 's' : '') + ' sold out · from ' + money(minSold, 0) + '</span><span class="see">see all ›</span></button>';
        }
        if (live.length) soon.forEach(function (v) {   // when nothing is live, soon tickets show as cards above, not here
          out += '<div class="phsum-next"><span class="pn">' + v.title + '</span><span class="pp">' + money(v.priceCents, 0) + '</span><span class="ps">soon</span></div>';
        });
        if (!sold.length) out += '<button class="phsum-all" onclick="OMC.togglePhases()">See all phases ›</button>';
        out += '</div>';
      }
      out += urgency;
    }
    byId('omc-ladder').innerHTML = out;
  }
  function pickTicket(id) { var v = SHOP.tickets.find(function (x) { return String(x.id) === String(id); }); if (!v || v.status !== 'live') { toast('Sold out'); return; } CART.variant = v.id; renderTickets(); updateFoot(); }
  function setQty(d) {
    CART.qty = Math.max(1, Math.min(MAXQ, CART.qty + d)); if (CART.stayQty > stayMax()) CART.stayQty = stayMax(); syncGuests();
    // Shuttle-only: a chosen departure with fewer seats than the new passenger count is released, with the reason.
    if (MODE === 'shuttle') ['in', 'out'].forEach(function (dir) {
      var id = dir === 'in' ? CART.shIn : CART.shOut; if (id === 'none') return;
      var o = shOpt(dir, id); if (o && o.hasCount && o.left < CART.qty) { if (dir === 'in') CART.shIn = 'none'; else CART.shOut = 'none'; toast(seatsMsg(o)); }
    });
    if (HAS.tickets) renderTickets(); if (TYPES[FSTEP] === 'stay') renderStay(); if (TYPES[FSTEP] === 'shuttle') renderShuttle(); updateFoot();
  }
  function togglePhases() { phasesOpen = !phasesOpen; renderTickets(); }
  function sleepsLabel(s) { return /^\s*\d+\s*$/.test(s) ? 'Sleeps ' + String(s).trim() : s; }

  /* ---------- STEP · airport shuttle (shuttle-only mode) ---------- */
  function pickShuttle(dir, id) {
    if (id !== 'none') {
      var o = shOpt(dir, id); if (!o || !o.available) { toast('Sold out'); return; }
      if (o.hasCount && CART.qty > o.left) { toast(seatsMsg(o)); return; }   // fewer seats than passengers
    }
    if (dir === 'in') CART.shIn = id; else CART.shOut = id;
    renderShuttle(); updateFoot();
  }
  function renderShuttle() {
    byId('omc-shuttle-pax').innerHTML = '<div class="stayqty"><div class="sq-l">How many passengers?<small>One seat per person</small></div>' + qStepper() + '</div>';
    function legHTML(dir) {
      var list = SHOP.shuttle[dir] || [], cur = (dir === 'in' ? CART.shIn : CART.shOut), out = '';
      list.forEach(function (o) {
        if (o.id === 'none') return;
        var sel = String(o.id) === String(cur);
        var tooFew = o.available && o.hasCount && o.left < CART.qty;   // fewer seats than passengers → dimmed; a tap explains why
        out += '<div class="tkcard' + (sel ? ' sel' : '') + ' pick' + ((o.available && !tooFew) ? '' : ' dis') + '"' + (o.available ? ' onclick="OMC.pickShuttle(\'' + dir + '\',\'' + o.id + '\')"' : '') + '>' +
          '<div class="tk-top"><span class="tk-rad"></span><div class="tk-info"><div class="tk-nm" style="font-size:16px">' + o.title + '</div>' +
          (o.hasCount ? seatBadge(o) : (o.available ? '' : '<span class="badge b-sold">Sold out</span>')) + '</div>' +
          '<div class="tk-rt"><div class="tk-pr" style="font-size:18px">' + money(o.priceCents, 0) + '</div><div class="tk-pu">per seat</div></div></div></div>';
      });
      out += '<button class="skiprow' + (cur === 'none' ? ' on' : '') + '" onclick="OMC.pickShuttle(\'' + dir + '\',\'none\')"><span class="ok">' + CHECK + '</span><span>I don’t need ' + (dir === 'in' ? 'an arrival' : 'a departure') + ' transfer</span></button>';
      return out;
    }
    byId('omc-shuttle-in').innerHTML = legHTML('in');
    byId('omc-shuttle-out').innerHTML = legHTML('out');
    updateFoot();
  }

  /* ---------- STEP 2 · stay ---------- */
  var STAYCAP = {
    onsite: 'Sleep on the festival grounds — steps from the stages, in the pine forest or by the beach.',
    offsite: 'Stay nearby — hotels, houses and Silent Camp, a short drive or shuttle from site.'
  };
  function setStayCat(cat) { CART.stayCat = cat; renderStay(); }
  function renderStay() {
    var sel = stayOpt();
    // Accommodation-only has no ticket step to set the group size → its own guest counter here.
    var sq = byId('omc-stayqty');
    if (sq) sq.innerHTML = !HAS.tickets
      ? '<div class="stayqty"><div class="sq-l">How many guests?<small>We\'ll flag places too small for your group</small></div>' + qStepper() + '</div>'
      : '';
    byId('omc-stay-selected').innerHTML = (sel && sel.id !== 'none') ?
      '<div class="staysel"><div class="ok">' + CHECK + '</div><div class="b"><b>' + sel.title + (sel.multi ? ' × ' + CART.stayQty : '') + '</b><span>' +
      (sel.multi
        ? (stayFree() ? 'Free' : money(stayTotalCents(sel), 0)) + ' · ' + CART.stayQty + ' ' + (CART.stayQty > 1 ? stayUnitWord(sel).many : stayUnitWord(sel).one)
        : money(sel.priceCents, 0) + ' for the week' + (perPersonCents(sel.priceCents) ? ' · ' + money(perPersonCents(sel.priceCents), 0) + ' pp' : '')) +
      '</span></div><button class="rm" onclick="OMC.selectStay(\'none\')">Remove</button></div>' : '';
    byId('omc-seg-onsite').classList.toggle('on', CART.stayCat === 'onsite');
    byId('omc-seg-offsite').classList.toggle('on', CART.stayCat === 'offsite');
    byId('omc-segcap').textContent = STAYCAP[CART.stayCat];
    // Don't hide by capacity — show everything, but grey out stays too small for the group.
    var list = SHOP.stay.filter(function (s) { return s.cat === CART.stayCat; });
    // order: fits & available first, then too-small, then sold-out
    function rank(s) { return !s.available ? 2 : (fitsGroup(s) ? 0 : 1); }
    list.sort(function (a, b) { return rank(a) - rank(b); });
    byId('omc-staylist').innerHTML = list.length ? list.map(function (s) {
      var on = s.id === CART.stay, cap = capacityOf(s);
      var soldout = !s.available, tooSmall = s.available && !fitsGroup(s);
      var tag = on ? '<span class="sc-tag sel">Selected</span>'
        : soldout ? '<span class="sc-tag sold">Sold out</span>'
          : tooSmall ? '<span class="sc-tag cap">Sleeps ' + cap + '</span>' : '';
      var nImg = (s.images && s.images.length) ? s.images.length : (s.img ? 1 : 0);
      var priceMain = (stayFree() && s.multi) ? '<span class="pv-free">Free</span>' : money(s.priceCents, 0);
      var priceSub = s.multi ? (stayFree() ? (FREE_STAY ? FREE_STAY_LABEL : 'incl. SUNRISE') : 'per ' + stayUnitWord(s).one) : 'for the week';
      var foot = tooSmall ? '<div class="toosmall">⚠ Too small for ' + CART.qty + ' guests</div>' : '<div class="smore">View details ›</div>';
      return '<div class="staycard' + (on ? ' on' : '') + (soldout || tooSmall ? ' dis' : '') + '" onclick="OMC.openStay(\'' + s.id + '\')">' +
        '<div class="sc-media">' +
          (s.img ? '<img class="sc-img" src="' + s.img + '" alt="" loading="lazy">' : '<div class="sc-img noimg"></div>') +
          tag +
          (nImg > 1 ? '<span class="sc-count">📷 ' + nImg + '</span>' : '') +
        '</div>' +
        '<div class="sc-body"><div class="sc-row">' +
          '<div class="sc-nm">' + s.title + '</div>' +
          '<div class="sc-price">' + priceMain + '<small>' + priceSub + '</small>' +
          (!s.multi && perPersonCents(s.priceCents) ? '<em>' + money(perPersonCents(s.priceCents), 0) + ' / person</em>' : '') + '</div>' +
        '</div>' +
        (s.desc ? '<div class="sc-desc">' + s.desc + '</div>' : '') + foot +
        '</div></div>';
    }).join('') : '<div class="fs-sub">No options in this category right now.</div>';
    // Skip stays available but quiet — content sells the stay, "Next" is never blocked.
    // Accommodation-only has no "skip" (booking a stay is the whole point).
    byId('omc-stayskip').innerHTML = MODE === 'full'
      ? '<button class="skiprow' + (CART.stay === 'none' ? ' on' : '') + '" onclick="OMC.selectStay(\'none\')">' +
        '<span class="ok">' + CHECK + '</span><span>I\'ll sort my own stay — <b>continue without accommodation</b></span></button>'
      : '';
  }
  // sticky-footer price content — total (× pitches for "own" stays) + per-person for the group
  function stayPriceHTML(s) {
    var tot = stayTotalCents(s), pp = perPersonCents(tot);
    var ppLine = pp ? '<span class="pp2">' + money(pp) + ' / person</span>' : '';
    if (s.multi) { var w = stayUnitWord(s);
      if (stayFree()) return '<span class="pv pv-free">Free</span><span class="pu">' + CART.stayQty + ' ' + (CART.stayQty > 1 ? w.many : w.one) + ' · ' + (FREE_STAY ? FREE_STAY_LABEL : 'included with SUNRISE') + '</span>';
      return '<span class="pv">' + money(tot) + '</span><span class="pu">' + CART.stayQty + ' ' + (CART.stayQty > 1 ? w.many : w.one) + ' · ' + money(s.priceCents) + ' each</span>' + ppLine; }
    return '<span class="pv">' + money(tot) + '</span><span class="pu">for the full week</span>' + ppLine;
  }
  function openStayDetail(id) {
    var s = SHOP.stay.find(function (x) { return x.id === id; }); if (!s) return;
    stayDetailId = id;
    if (s.multi && CART.stay !== id) CART.stayQty = 1; // fresh candidate starts at 1 pitch
    var selected = CART.stay === id;
    // One fact per chip, no repeats: capacity, rooms, then the single location/transfer fact.
    var facts = [];
    if (s.sleeps) facts.push(sleepsLabel(s.sleeps));
    if (s.rooms) facts.push(s.rooms + ' room' + (s.rooms == 1 ? '' : 's'));
    facts.push(s.cat === 'onsite' ? 'On the festival grounds' : 'Off the festival grounds');
    var imgs = s.images && s.images.length ? s.images : (s.img ? [s.img] : []);
    byId('omc-staysheet').innerHTML =
      '<div class="shead">' +
      (imgs.length ? '<div class="sgal" id="omc-sgal">' + imgs.map(function (u) { return '<div class="sgal-slide"><div class="bg" style="background-image:url(\'' + u + '\')"></div><img src="' + u + '" alt="" loading="lazy"></div>'; }).join('') + '</div>' : '') +
      (imgs.length > 1 ? '<button class="sgal-nav prev" onclick="OMC.galNav(event,-1)" aria-label="Previous photo">‹</button><button class="sgal-nav next" onclick="OMC.galNav(event,1)" aria-label="Next photo">›</button>' : '') +
      (imgs.length > 1 ? '<div class="sgal-dots" id="omc-sgal-dots">' + imgs.map(function (_, ix) { return '<i' + (ix === 0 ? ' class="on"' : '') + '></i>'; }).join('') + '</div>' : '') +
      '<button class="sclose" onclick="OMC.closeStay()">✕</button></div>' +
      '<div class="sbody">' +
      '<div class="s-stick"><div class="s-title">' + s.title + '</div><div class="smeta">' + facts.map(function (f) { return '<span>' + f + '</span>'; }).join('') + '</div></div>' +
      '<div class="s-content">' +
      (s.lead ? '<div class="sbio-lead">' + s.lead + '</div>' : '') +
      (s.long && s.long !== s.lead ? '<div class="sbio">' + s.long + '</div>' : '') +
      (s.features.length ? '<div class="splots" style="margin-top:14px">' + s.features.map(function (f) { return '<span>✓&nbsp; ' + f + '</span>'; }).join('') + '</div>' : '') +
      '</div>' +
      '</div>' +
      '<div class="sfoot">' +
      (s.available && !fitsGroup(s) ? '<div class="stay-note">⚠️ Sleeps up to ' + capacityOf(s) + ' · too small for your ' + CART.qty + ' guests. Reduce guests to ' + capacityOf(s) + ' in Step 1, or choose a larger stay.</div>' : '') +
      (s.multi ? '<div class="pitchrow"><div class="pitchlbl">' + stayUnitWord(s).ask + '<small>' + stayUnitWord(s).hint + '</small></div>' +
        '<div class="qty"><button id="omc-pq-minus"' + (CART.stayQty <= 1 ? ' disabled' : '') + ' onclick="OMC.setStayQty(-1)">−</button>' +
        '<span class="n" id="omc-pq-n">' + CART.stayQty + '</span>' +
        '<button id="omc-pq-plus"' + (CART.stayQty >= stayMax() ? ' disabled' : '') + ' onclick="OMC.setStayQty(1)">+</button></div></div>' : '') +
      '<div class="sfoot-main"><div class="sf-price" id="omc-sf-price">' + stayPriceHTML(s) + '</div>' +
      (!s.available ? '<button class="cta" disabled style="opacity:.5">Sold out</button>' :
        !fitsGroup(s) ? '<button class="cta" disabled style="opacity:.5">Too small for ' + CART.qty + ' guests</button>' :
          '<button class="cta" onclick="OMC.selectStay(\'' + s.id + '\')">' + (selected ? '✓ Selected' : (s.multi ? 'Add to booking' : 'Select this stay')) + '</button>') + '</div>' +
      '</div>';
    byId('omc-stay-overlay').classList.add('show');
    // gallery dots ↔ swipe position
    var gal = byId('omc-sgal'), dots = byId('omc-sgal-dots');
    clearInterval(galTimer); galTimer = null;
    if (gal && dots) {
      gal.addEventListener('scroll', function () {
        var ix = Math.round(gal.scrollLeft / gal.clientWidth);
        Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === ix); });
      }, { passive: true });
    }
    // auto-advance until the guest interacts
    if (gal && imgs.length > 1) {
      galTimer = setInterval(function () {
        var next = Math.round(gal.scrollLeft / gal.clientWidth) + 1;
        if (next >= imgs.length) next = 0;
        // Synchronous scrollLeft — reliable everywhere (CSS smooth / rAF can't be trusted under
        // reduced-motion or backgrounded tabs). scroll-snap makes the advance land cleanly.
        gal.scrollLeft = next * gal.clientWidth;
      }, 3800);
      gal.addEventListener('pointerdown', function () { clearInterval(galTimer); galTimer = null; }, { once: true });
    }
  }
  function closeStayDetail(e) { if (e && e.target !== e.currentTarget) return; clearInterval(galTimer); galTimer = null; byId('omc-stay-overlay').classList.remove('show'); }
  // Adjust the number of pitches for an "own tent" (multi) stay, updating the sheet in place.
  function setStayQty(d) {
    CART.stayQty = Math.max(1, Math.min(stayMax(), CART.stayQty + d));
    var n = byId('omc-pq-n'); if (n) n.textContent = CART.stayQty;
    var mn = byId('omc-pq-minus'); if (mn) mn.disabled = CART.stayQty <= 1;
    var pl = byId('omc-pq-plus'); if (pl) pl.disabled = CART.stayQty >= stayMax();
    var s = SHOP.stay.find(function (x) { return x.id === stayDetailId; });
    var pr = byId('omc-sf-price'); if (pr && s) pr.innerHTML = stayPriceHTML(s);
    updateFoot();
  }
  function selectStay(id) {
    var s = SHOP.stay.find(function (x) { return x.id === id; });
    if (s && s.id !== 'none' && !s.available) { toast('That stay is sold out'); return; }
    if (s && s.id !== 'none' && !fitsGroup(s)) { toast('Sleeps up to ' + capacityOf(s) + ' — too small for ' + CART.qty + ' guests'); return; }
    if (!s || !s.multi) CART.stayQty = 1; // non-multi stays are always one unit
    CART.stay = id; if (s && s.cat) CART.stayCat = s.cat; closeStayDetail(); renderStay(); updateFoot();
    toast(id === 'none' ? 'No accommodation — you can add one any time' : (s.multi ? s.title + ' × ' + CART.stayQty + ' added' : s.title + ' added'));
  }

  /* ---------- wellness · sessions step (mode: wellness) ----------
     Session cards → sheet with the festival day strip → time chips. Multi-session basket in CART.sessions. */
  function sessionById(id) { return SHOP.sessions.find(function (s) { return s.id === String(id); }); }
  function slotOf(sess, slotId) { return sess ? sess.slots.find(function (s) { return s.id === String(slotId); }) : null; }
  function maxQtyFor(sess, slot) { return sess.kind === '1to1' ? 1 : Math.max(1, Math.min(slot.left, MAX_PER_SLOT)); }
  function findLine(variantId) { return CART.sessions.findIndex(function (l) { return String(l.variantId) === String(variantId); }); }
  function linesFor(sessId) { return CART.sessions.filter(function (l) { return l.sessionId === String(sessId); }); }
  function bookerName() { var g = CART.guests[0] || {}; return ((g.first || '') + ' ' + (g.last || '')).replace(/\s+/g, ' ').trim(); }
  function attendeeName(l) { return (l.attendee && l.attendee.touched) ? l.attendee.name : bookerName(); }
  function sessionCents() { var c = 0; CART.sessions.forEach(function (l) { c += l.priceCents * l.qty; }); return c; }
  function dayState(sess, iso) { var ds = sess.byDay[iso] || []; if (!ds.length) return 'none'; return ds.some(function (s) { return s.available; }) ? 'some' : 'full'; }
  function dayHas(sess, iso) { return linesFor(sess.id).some(function (l) { return l.dateISO === iso; }); }
  function fmtDay(iso) { var d = days().find(function (x) { return x.iso === iso; }); return d ? d.dow + ' ' + d.d + ' ' + d.mon : iso; }
  function priceUnit(sess) { return sess.kind === 'group' ? 'per person' : sess.kind === 'workshop' ? 'material fee' : sess.kind === 'anytime' ? 'each' : 'per session'; }
  function slotSub(sess, slot) {
    if (!slot.available) return sess.kind === '1to1' ? 'Taken' : 'Full';
    if (sess.kind === 'group') return (sess.groupCap && slot.left < sess.groupCap) ? slot.left + ' of ' + sess.groupCap + ' spots' : (sess.groupCap ? 'up to ' + sess.groupCap : '');
    if (sess.kind === 'workshop') return (slot.left !== Infinity && slot.left <= 10) ? slot.left + ' spots left' : '';
    return '';
  }
  // Same day + same effective attendee + overlapping minutes → warn (never block).
  function overlapsWith(line) {
    return CART.sessions.find(function (o) {
      if (o === line || !o.dateISO || o.dateISO !== line.dateISO) return false;
      if (attendeeName(o).toLowerCase() !== attendeeName(line).toLowerCase()) return false;
      return line.startMin < o.endMin && o.startMin < line.endMin;
    });
  }
  function pickSlot(sessId, slotId) {
    var sess = sessionById(sessId), slot = slotOf(sess, slotId); if (!sess || !slot) return;
    var ix = findLine(slot.variantId);
    if (ix > -1) { removeSession(ix); return; } // tap the booked time again = remove it
    if (!slot.available) { toast(sess.kind === '1to1' ? 'That time is already taken' : 'That time is fully booked'); return; }
    var line = { variantId: slot.variantId, sessionId: sess.id, productHandle: sess.handle, productTitle: sess.title,
                 slotTitle: slot.title, slotId: slot.id, dateISO: slot.dateISO, startMin: slot.startMin, endMin: slot.endMin,
                 priceCents: slot.priceCents, qty: 1, location: sess.location, attendee: { name: '', touched: false } };
    CART.sessions.push(line);
    toast(sess.title + ' · ' + (slot.dateISO ? fmtDay(slot.dateISO) + ' ' + slot.timeLabel : slot.title) + ' added');
    var o = overlapsWith(line);
    if (o) setTimeout(function () { toast('Heads up — overlaps with ' + o.productTitle + ' (' + o.slotTitle + ')'); }, 2100);
    renderSessionSheet(); renderWellness(); updateFoot();
  }
  function removeSession(idx, ev) {
    if (ev && ev.stopPropagation) ev.stopPropagation();
    if (idx < 0 || idx >= CART.sessions.length) return;
    CART.sessions.splice(idx, 1);
    if (wlOpen) renderSessionSheet();
    if (TYPES[FSTEP] === 'wellness') renderWellness();
    if (TYPES[FSTEP] === 'guests') renderAttendees();
    updateFoot();
  }
  function setSessionQty(idx, d) {
    var l = CART.sessions[idx]; if (!l) return;
    var sess = sessionById(l.sessionId), slot = slotOf(sess, l.slotId); if (!sess || !slot) return;
    l.qty = Math.max(1, Math.min(maxQtyFor(sess, slot), l.qty + d));
    if (wlOpen) renderSessionSheet();
    if (TYPES[FSTEP] === 'wellness') renderWellness();
    updateFoot();
  }
  // Slot-less "anytime" add-ons (e.g. energy shots): just a quantity, no calendar.
  function setAnytimeQty(sessId, d) {
    var sess = sessionById(sessId); if (!sess || !sess.slots.length) return;
    var slot = sess.slots[0], ix = findLine(slot.variantId);
    if (ix === -1) {
      if (d <= 0) return;
      if (!slot.available) { toast('Not available right now'); return; }
      CART.sessions.push({ variantId: slot.variantId, sessionId: sess.id, productHandle: sess.handle, productTitle: sess.title,
        slotTitle: slot.title, slotId: slot.id, dateISO: null, startMin: 0, endMin: 0, priceCents: slot.priceCents, qty: 1,
        location: sess.location, attendee: { name: '', touched: false } });
      toast(sess.title + ' added');
    } else {
      var l = CART.sessions[ix], nq = l.qty + d;
      if (nq <= 0) CART.sessions.splice(ix, 1); else l.qty = Math.min(Math.min(slot.left, MAX_PER_SLOT), nq);
    }
    renderWellness(); updateFoot();
  }
  function setAttendee(idx, v) { var l = CART.sessions[idx]; if (!l) return; l.attendee.name = v; l.attendee.touched = String(v).trim() !== ''; }
  function chipsFor(s) { return [s.duration, s.location, s.eligibility].filter(Boolean).map(function (c) { return '<span>' + esc(c) + '</span>'; }).join(''); }

  function renderWellness() {
    var bar = byId('omc-wl-bar'), list = byId('omc-wl-list'), any = byId('omc-wl-anytime'); if (!list) return;
    var n = CART.sessions.reduce(function (a, l) { return a + l.qty; }, 0);
    if (bar) bar.innerHTML = n ? '<div class="wl-bar"><span class="ok">' + CHECK + '</span><span>' + n + (n > 1 ? ' bookings' : ' booking') + ' in your order · ' + money(sessionCents()) + '</span></div>' : '';
    list.innerHTML = SHOP.sessions.filter(function (s) { return s.kind !== 'anytime'; }).map(function (s) {
      var mine = linesFor(s.id), allFull = s.slots.length > 0 && !s.slots.some(function (x) { return x.available; });
      var booked = mine.map(function (l) { var gi = CART.sessions.indexOf(l), sl = slotOf(s, l.slotId);
        return '<span>Booked: ' + (l.dateISO ? fmtDay(l.dateISO) + ' · ' + (sl ? sl.timeLabel : '') : l.slotTitle) + (l.qty > 1 ? ' × ' + l.qty : '') + '<b onclick="OMC.removeSession(' + gi + ',event)" aria-label="Remove">✕</b></span>'; }).join('');
      var tag = mine.length ? '<span class="sc-tag sel">✓ In your booking</span>' : allFull ? '<span class="sc-tag sold">Fully booked</span>' : '';
      var chips = chipsFor(s);
      return '<div class="staycard' + (mine.length ? ' sel' : '') + (allFull ? ' dis' : '') + '" onclick="OMC.openSession(\'' + s.id + '\')">' +
        '<div class="sc-media">' + (s.img ? '<img class="sc-img" src="' + s.img + '" alt="" loading="lazy">' : '<div class="sc-img"></div>') + tag + '</div>' +
        '<div class="sc-body"><div class="sc-row"><div class="sc-nm">' + s.title + '</div><div class="sc-price">' + money(s.priceFrom) + '<small>' + priceUnit(s) + '</small></div></div>' +
        (chips ? '<div class="sc-chips">' + chips + '</div>' : '') +
        (s.desc ? '<div class="sc-desc">' + s.desc + '</div>' : '') +
        (booked ? '<div class="sc-booked">' + booked + '</div>' : '') +
        '</div></div>';
    }).join('') || (SHOP.sessions.length ? '' : '<div class="wl-empty">No sessions are on sale yet — check back soon.</div>');
    if (any) {
      var anys = SHOP.sessions.filter(function (s) { return s.kind === 'anytime'; });
      any.innerHTML = anys.length ? '<div class="fgroup-t" style="margin-top:22px">Anytime add-ons</div>' + anys.map(function (s) {
        var slot = s.slots[0] || { left: 0, available: false }, ix = findLine(slot.variantId), q = ix > -1 ? CART.sessions[ix].qty : 0;
        var mx = Math.min(slot.left, MAX_PER_SLOT);
        return '<div class="wany' + (q ? ' on' : '') + '">' + (s.img ? '<img class="wa-img" src="' + s.img + '" alt="">' : '') +
          '<div class="wa-b"><div class="wa-nm">' + s.title + '</div><div class="wa-sub">' + esc([s.duration, s.location, s.eligibility].filter(Boolean).join(' · ')) + (s.desc ? ' — ' + s.desc : '') + '</div><div class="wa-pr">' + money(s.priceFrom) + ' <small>' + priceUnit(s) + '</small></div></div>' +
          '<div class="qty"><button' + (q <= 0 ? ' disabled' : '') + ' onclick="OMC.setAnytimeQty(\'' + s.id + '\',-1)">−</button><span class="n">' + q + '</span><button' + ((q >= mx || !slot.available) ? ' disabled' : '') + ' onclick="OMC.setAnytimeQty(\'' + s.id + '\',1)">+</button></div></div>';
      }).join('') : '';
    }
  }
  function openSession(id) {
    var s = sessionById(id); if (!s) return;
    wlOpen = s.id;
    if (!wlDay[s.id]) { var first = days().find(function (d) { return dayState(s, d.iso) === 'some'; }) || days()[0]; wlDay[s.id] = first ? first.iso : null; }
    var chips = chipsFor(s);
    byId('omc-wlsheet').innerHTML =
      '<div class="shead">' + (s.img ? '<img class="wl-hero" src="' + s.img + '" alt="">' : '<div class="noimg"></div>') + '<button class="sclose" onclick="OMC.closeSession()">✕</button></div>' +
      '<div class="sbody">' +
      '<div class="wl-head"><div class="s-title">' + s.title + '</div>' + (chips ? '<div class="smeta">' + chips + '</div>' : '') + '</div>' +
      '<div class="s-stick"><div class="wday-strip" id="omc-wl-days">' + renderDayStrip(s) + '</div></div>' +
      '<div class="s-content"><div class="wslots" id="omc-wl-slots">' + renderSlots(s) + '</div>' +
      (s.other.length ? '<div class="fgroup-t">Other options</div><div class="wslots">' + s.other.map(function (x) { return slotChip(s, x); }).join('') + '</div>' : '') +
      (s.long ? '<div class="sbio" style="margin-top:18px">' + s.long + '</div>' : (s.desc ? '<div class="sbio-lead" style="margin-top:18px">' + s.desc + '</div>' : '')) +
      '</div></div>' +
      '<div class="sfoot"><div class="wl-picked" id="omc-wl-picked">' + renderPicked(s) + '</div>' +
      '<div class="sfoot-main"><div class="sf-price" id="omc-wl-sub">' + pickedSub(s) + '</div><button class="cta" onclick="OMC.closeSession()">Done</button></div></div>';
    byId('omc-wl-overlay').classList.add('show');
    var strip = byId('omc-wl-days'), on = strip && strip.querySelector('.wday.on');
    if (strip && on) strip.scrollLeft = Math.max(0, on.offsetLeft - strip.clientWidth / 2 + on.offsetWidth / 2);
  }
  function renderDayStrip(s) {
    return days().map(function (d) {
      var st = dayState(s, d.iso), has = dayHas(s, d.iso), on = wlDay[s.id] === d.iso;
      return '<button class="wday ' + st + (on ? ' on' : '') + (has ? ' has' : '') + '"' + (st === 'none' ? ' disabled' : '') + ' onclick="OMC.pickDay(\'' + s.id + '\',\'' + d.iso + '\')">' +
        '<span class="wd-dow">' + d.dow + '</span><span class="wd-n">' + d.d + '</span><span class="wd-m">' + d.mon + '</span><i class="dot"></i></button>';
    }).join('');
  }
  function slotChip(s, x) {
    var on = findLine(x.variantId) > -1, sub = slotSub(s, x);
    if (!sub && x.priceCents !== s.priceFrom) sub = money(x.priceCents) + (x.durMin ? ' · ' + x.durMin + ' min' : '');
    var low = s.kind === 'group' && s.groupCap && x.available && x.left <= Math.max(1, Math.floor(s.groupCap / 3));
    return '<button class="wslot' + (on ? ' on' : '') + (x.available ? '' : ' dis') + (low ? ' low' : '') + '"' + (x.available ? ' onclick="OMC.pickSlot(\'' + s.id + '\',\'' + x.id + '\')"' : ' disabled') + '>' +
      '<span class="t">' + (x.timeLabel || x.title) + '</span>' + (sub ? '<span class="left">' + sub + '</span>' : '') + '</button>';
  }
  function renderSlots(s) {
    var iso = wlDay[s.id], list = iso ? (s.byDay[iso] || []) : [];
    if (!list.length) return '<div class="wl-empty">No times on this day — pick another day above.</div>';
    return list.map(function (x) { return slotChip(s, x); }).join('');
  }
  function renderPicked(s) {
    var mine = linesFor(s.id);
    if (!mine.length) return '<div class="wl-empty">Pick a day and a time above.</div>';
    return mine.map(function (l) {
      var gi = CART.sessions.indexOf(l), slot = slotOf(s, l.slotId), mx = slot ? maxQtyFor(s, slot) : 1;
      return '<div class="wl-row"><div>' + (l.dateISO ? fmtDay(l.dateISO) + ' · ' + (slot ? slot.timeLabel : '') : l.slotTitle) + '<small>' + money(l.priceCents) + ' ' + priceUnit(s) + (l.qty > 1 ? ' × ' + l.qty : '') + '</small></div>' +
        (mx > 1 ? '<div class="qty"><button' + (l.qty <= 1 ? ' disabled' : '') + ' onclick="OMC.setSessionQty(' + gi + ',-1)">−</button><span class="n">' + l.qty + '</span><button' + (l.qty >= mx ? ' disabled' : '') + ' onclick="OMC.setSessionQty(' + gi + ',1)">+</button></div>' : '') +
        '<button class="rm" onclick="OMC.removeSession(' + gi + ',event)" aria-label="Remove">✕</button></div>';
    }).join('');
  }
  function pickedSub(s) { var c = 0; linesFor(s.id).forEach(function (l) { c += l.priceCents * l.qty; }); return c ? '<b>' + money(c) + '</b><small>this session</small>' : '<small>from ' + money(s.priceFrom) + ' ' + priceUnit(s) + '</small>'; }
  function pickDay(sessId, iso) {
    var s = sessionById(sessId); if (!s) return; wlDay[s.id] = iso;
    var strip = byId('omc-wl-days'); if (strip) Array.prototype.forEach.call(strip.children, function (b) { b.classList.toggle('on', (b.getAttribute('onclick') || '').indexOf("'" + iso + "'") > -1); });
    var sl = byId('omc-wl-slots'); if (sl) sl.innerHTML = renderSlots(s);
    // Bring the times into view: park the (sticky) day strip at the top of the scroll area.
    var sheet = byId('omc-wlsheet'), body = sheet && sheet.querySelector('.sbody'), stick = body && body.querySelector('.s-stick');
    if (body && stick) { var top = stick.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop; if (body.scrollTop < top) { body.scrollTo ? body.scrollTo({ top: top, behavior: 'smooth' }) : (body.scrollTop = top); } }
  }
  // Re-render the sheet's dynamic parts in place — never the strip DOM, so its scroll position survives.
  function renderSessionSheet() {
    var s = wlOpen ? sessionById(wlOpen) : null; if (!s) return;
    var sl = byId('omc-wl-slots'); if (sl) sl.innerHTML = renderSlots(s);
    var pk = byId('omc-wl-picked'); if (pk) pk.innerHTML = renderPicked(s);
    var sb = byId('omc-wl-sub'); if (sb) sb.innerHTML = pickedSub(s);
    var strip = byId('omc-wl-days'); if (strip) Array.prototype.forEach.call(strip.children, function (b) {
      var m = /'(\d{4}-\d{2}-\d{2})'/.exec(b.getAttribute('onclick') || ''); if (!m) return;
      var st = dayState(s, m[1]); b.classList.remove('none', 'some', 'full'); b.classList.add(st); b.classList.toggle('has', dayHas(s, m[1])); b.disabled = st === 'none';
    });
  }
  function closeSession(e) { if (e && e.target !== e.currentTarget) return; var ov = byId('omc-wl-overlay'); if (ov) ov.classList.remove('show'); wlOpen = null; if (TYPES[FSTEP] === 'wellness') renderWellness(); }
  // Guests step: one input per booked slot — who's attending (prefilled from the booker, editable).
  function renderAttendees() {
    var w = byId('omc-wl-attendees'); if (!w) return;
    var rows = CART.sessions.map(function (l, i) { return { l: l, i: i }; }).filter(function (r) { return r.l.dateISO; });
    if (!rows.length) { w.innerHTML = ''; return; }
    w.innerHTML = '<div class="fgroup-t">Who’s attending?</div><div class="wl-att">' + rows.map(function (r) {
      var s = sessionById(r.l.sessionId), slot = slotOf(s, r.l.slotId);
      return '<div class="field"><label>' + r.l.productTitle + ' · ' + fmtDay(r.l.dateISO) + ' ' + (slot ? slot.timeLabel : '') +
        (r.l.qty > 1 ? '<small>Party of ' + r.l.qty + ' — lead attendee</small>' : '<small>Leave as is if it’s you</small>') + '</label>' +
        '<input id="omc-wl-att-' + r.i + '" value="' + esc(attendeeName(r.l)) + '" placeholder="Attendee name" autocomplete="off" oninput="OMC.setAttendee(' + r.i + ',this.value)"></div>';
    }).join('') + '</div>';
  }
  // Before committing, refresh availability from the storefront. Only `available` is exposed there
  // (no inventory counts); a 404 / network error = unknown → proceed and let cart/add.js be the judge.
  function recheckSessions() {
    var handles = []; CART.sessions.forEach(function (l) { if (handles.indexOf(l.productHandle) === -1) handles.push(l.productHandle); });
    return Promise.all(handles.map(function (h) {
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          var s = SHOP.sessions.find(function (x) { return x.handle === h; }); if (!s) return;
          p.variants.forEach(function (v) { var sl = s.slots.find(function (x) { return String(x.variantId) === String(v.id); }); if (sl) { sl.available = !!v.available; if (!v.available) sl.left = 0; } });
        });
    })).then(function () {
      return CART.sessions.filter(function (l) { var s = sessionById(l.sessionId), sl = slotOf(s, l.slotId); return sl && !sl.available; });
    });
  }
  function dropLines(bad, msg) {
    bad.forEach(function (l) { var ix = CART.sessions.indexOf(l); if (ix > -1) CART.sessions.splice(ix, 1); });
    toast(msg);
    if (FSTEP > 0) goStep(0);
  }
  // Shopify refused an add (422 — sold out / over capacity): drop the offending line and send the guest back to re-pick.
  function handleAddFailure(e) {
    var msg = String((e && e.message) || '');
    if (!/sold out|can.t add more|already in your cart|not available|unavailable|inventory|out of stock/i.test(msg)) { toast('Something went wrong — please try again'); return; }
    var matched = CART.sessions.filter(function (l) { return (l.productTitle && msg.indexOf(l.productTitle) > -1) || (l.slotTitle && msg.indexOf(l.slotTitle) > -1); });
    if (matched.length) { dropLines(matched, 'That slot was just taken — pick another time'); return; }
    recheckSessions().then(function (bad) { dropLines(bad, bad.length ? 'That slot was just taken — pick another time' : 'A slot is no longer available — please re-check your times'); });
  }

  /* ---------- STEP 3 · guests ---------- */
  function renderGuests() {
    var namesOnly = NAMES_ONLY, lbl = MODE === 'shuttle' ? 'Passenger' : MODE === 'wellness' ? 'Booker' : 'Guest';
    byId('omc-guestlist').innerHTML = CART.guests.map(function (g, i) {
      var open = i === openGuest, ok = guestComplete(g);
      var name = (g.first || g.last) ? (g.first + ' ' + g.last).trim() : (open ? (MODE === 'wellness' ? 'Name for the booking confirmation' : namesOnly ? 'Full name for the manifest' : 'Names must match photo ID') : 'Tap to add details');
      function gnd(x) { return '<div class="r' + (g.gender === x ? ' on' : '') + '" onclick="OMC.setGuest(' + i + ',\'gender\',\'' + x + '\')">' + x.charAt(0).toUpperCase() + x.slice(1) + '</div>'; }
      function sh(dir, val) { var o = shOpt(dir, val); return '<button class="selectrow' + (val !== 'none' ? ' set' : '') + '" onclick="OMC.openPicker(' + i + ',\'' + dir + '\')"><span class="' + (val === 'none' ? 'ph' : '') + '">' + o.title + '</span><span class="cv">' + (o.priceCents ? money(o.priceCents) : '▾') + '</span></button>'; }
      // Everyone gives name + email; ticket/stay guests also need DOB (18+ check), gender and optional shuttle.
      var emailField = '<div class="field"><label>E-mail <span class="req">*</span></label><input type="email" name="email" autocomplete="email" inputmode="email" enterkeyhint="next" onkeydown="OMC.key(event)" value="' + esc(g.email) + '" placeholder="name@email.com" oninput="OMC.setGuest(' + i + ',\'email\',this.value)">' +
        '<div class="ferr" id="omc-gmailerr-' + i + '"' + ((g.email && !emailValid(g.email)) ? '' : ' style="display:none"') + '>Please enter a valid email address.</div></div>';
      var extra = namesOnly ? '' :
        '<div class="field"><label>Date of birth <span class="req">*</span></label><input type="date" name="birthday" autocomplete="bday" value="' + esc(g.dob) + '" min="' + SHOP.dobMin + '" max="' + SHOP.dobMax + '" onchange="OMC.setGuest(' + i + ',\'dob\',this.value)">' +
        '<div class="ferr" id="omc-gdoberr-' + i + '"' + (dobTooYoung(g) ? '' : ' style="display:none"') + '>Guests must be 18 or older at the festival (born on or before ' + SHOP.dobMax + ').</div></div>' +
        '<div class="field"><label>Gender <span class="req">*</span></label><div class="radios">' + gnd('male') + gnd('female') + gnd('other') + '</div></div>' +
        '<div class="shuttle-note">🚐 <span>Add <b>airport shuttle</b> for this guest — optional</span></div>' +
        '<div class="field"><label>' + esc(SHOP.shuttle.inTitle) + '</label>' + sh('in', g.shuttleIn) + '</div>' +
        '<div class="field"><label>' + esc(SHOP.shuttle.outTitle) + '</label>' + sh('out', g.shuttleOut) + '</div>';
      // Real <form> + standard autocomplete tokens so browser/iOS autofill engages.
      return '<div class="gcard' + (open ? ' open' : '') + '">' +
        '<div class="ghead" onclick="OMC.toggleGuest(' + i + ')"><div class="gi">' + (i + 1) + '</div>' +
        '<div class="gt">' + lbl + (MODE === 'wellness' ? '' : ' ' + (i + 1)) + '<small id="omc-gname-' + i + '">' + name + '</small></div>' +
        '<div class="warn" id="omc-gwarn-' + i + '"' + (ok ? ' style="display:none"' : '') + '></div><div class="chev">▾</div></div>' +
        '<div class="gbody"><form class="gform" autocomplete="on" onsubmit="return false">' +
        '<div class="field"><label>First name <span class="req">*</span></label><input name="first_name" autocomplete="given-name" enterkeyhint="next" onkeydown="OMC.key(event)" value="' + esc(g.first) + '" oninput="OMC.setGuest(' + i + ',\'first\',this.value)"></div>' +
        '<div class="field"><label>Last name <span class="req">*</span></label><input name="last_name" autocomplete="family-name" enterkeyhint="next" onkeydown="OMC.key(event)" value="' + esc(g.last) + '" oninput="OMC.setGuest(' + i + ',\'last\',this.value)"></div>' +
        emailField +
        extra +
        '</form></div></div>';
    }).join('');
    if (MODE === 'wellness') renderAttendees();
  }
  function esc(s) { return String(s || '').replace(/"/g, '&quot;'); }
  function toggleGuest(i) { openGuest = (openGuest === i ? -1 : i); renderGuests(); }
  // Text fields update in place (re-rendering mid-keystroke would steal focus and break autofill);
  // gender/DOB re-render (they change selected state / the inline error line).
  function setGuest(i, k, v) {
    CART.guests[i][k] = v;
    if (k === 'gender') { renderGuests(); updateFoot(); return; } // radio pick — safe to re-render
    var g = CART.guests[i];
    if (k === 'first' || k === 'last') {
      var nm = byId('omc-gname-' + i);
      if (nm) nm.textContent = (g.first + ' ' + g.last).trim() || (MODE === 'wellness' ? 'Name for the booking confirmation' : 'Names must match photo ID');
      // Wellness: untouched attendee inputs mirror the booker's name as it's typed (never the one being edited).
      if (MODE === 'wellness') CART.sessions.forEach(function (l, ix) { var inp = byId('omc-wl-att-' + ix); if (inp && !l.attendee.touched && document.activeElement !== inp) inp.value = bookerName(); });
    }
    // DOB updates the 18+ error in place — re-rendering here would rebuild the <input> mid-entry,
    // stealing focus and committing a half-typed year (the "0001" / year-0 calendar bug).
    if (k === 'dob') { var err = byId('omc-gdoberr-' + i); if (err) err.style.display = dobTooYoung(g) ? '' : 'none'; }
    // Email format error, shown once something's typed but it isn't a valid address.
    if (k === 'email') { var me = byId('omc-gmailerr-' + i); if (me) me.style.display = (g.email && !emailValid(g.email)) ? '' : 'none'; }
    var w = byId('omc-gwarn-' + i);
    if (w) w.style.display = guestComplete(g) ? 'none' : '';
    updateFoot();
  }
  // Enter (or the keyboard's "next") walks to the following field instead of doing nothing.
  function fieldKey(e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    var form = e.target.closest('.gform'); if (!form) return;
    var els = Array.prototype.slice.call(form.querySelectorAll('input'));
    var ix = els.indexOf(e.target);
    if (ix > -1 && ix < els.length - 1) els[ix + 1].focus(); else e.target.blur();
  }

  function openPicker(i, dir) {
    pickerCtx = { i: i, dir: dir };
    var opts = SHOP.shuttle[dir === 'in' ? 'in' : 'out'], cur = CART.guests[i][dir === 'in' ? 'shuttleIn' : 'shuttleOut'];
    byId('omc-pk-title').textContent = (dir === 'in' ? SHOP.shuttle.inTitle : SHOP.shuttle.outTitle) + ' · choose departure';
    byId('omc-pk-opts').innerHTML = opts.map(function (o) {
      var dis = o.available === false;
      return '<div class="opt' + (o.id === cur ? ' on' : '') + (dis ? ' dis' : '') + '"' + (dis ? '' : ' onclick="OMC.choosePicker(\'' + o.id + '\')"') + '>' +
        '<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap"><div class="on-dot"></div><div class="ol">' + o.title + '</div>' + (o.hasCount ? seatBadge(o) : '') + '</div>' +
        '<div class="op">' + (dis ? 'Sold out' : (o.priceCents ? money(o.priceCents, 0) : 'Free')) + '</div></div>';
    }).join('');
    byId('omc-picker').classList.add('show');
  }
  function choosePicker(id) { var c = pickerCtx; CART.guests[c.i][c.dir === 'in' ? 'shuttleIn' : 'shuttleOut'] = id; closePicker(); renderGuests(); updateFoot(); }
  function closePicker(e) { if (e && e.target !== e.currentTarget) return; byId('omc-picker').classList.remove('show'); }

  /* ---------- STEP 4 · review ---------- */
  function renderPromo() {
    var w = byId('omc-promo');
    if (CART.discount) {
      w.innerHTML = '<div class="promo-ok"><span class="tag">🏷️ ' + CART.discount + '</span><button class="rm" onclick="OMC.removePromo()">Remove</button></div>' +
        (CART.freePitch ? '<div class="promo-freecamp"><span class="ok">' + CHECK + '</span><span>Free camping added — <b>' + CART.freePitch.title + '</b> · one per order, free with this code</span></div>' : '');
    } else {
      w.innerHTML = '<div class="promo"><input id="omc-promoin" placeholder="Enter code" autocapitalize="characters"><button onclick="OMC.applyPromo()">Apply</button></div>';
    }
  }
  // A ticket-only code that grants one free bring-your-own pitch (added to the cart; its companion discount zeroes it).
  function freePitchFor(code) {
    if (MODE !== 'tickets' || !FREE_PITCH.length) return null;
    var up = String(code || '').toUpperCase(), pairs = [];
    FREE_PITCH.forEach(function (e) { e.codes.forEach(function (k) { if (k) pairs.push({ k: k, e: e }); }); });
    pairs.sort(function (a, b) { return b.k.length - a.k.length; });   // longest key first (e.g. CARAVANWEEKEND before WEEKEND)
    for (var i = 0; i < pairs.length; i++) { if (up.indexOf(pairs[i].k) > -1) return pairs[i].e; }
    return null;
  }
  function applyPromo() { var c = (byId('omc-promoin').value || '').trim().toUpperCase(); if (!c) return; CART.discount = c; CART.freePitch = freePitchFor(c); renderPromo(); commitCart(); }
  function removePromo() { CART.discount = null; CART.freePitch = null; renderPromo(); commitCart(); }
  // A missing product photo gets a neutral glyph tile — never an empty colored block.
  function li(img, title, sub, price, icon) {
    return '<div class="liserv">' + (img ? '<img class="th" src="' + img + '" alt="">' : '<div class="th ic">' + (icon || IC_TICKET) + '</div>') +
      '<div class="li-b"><div class="li-t">' + title + '</div>' + (sub ? '<div class="li-s">' + sub + '</div>' : '') + '</div>' +
      '<div class="li-p">' + price + '</div></div>';
  }
  // Per-line price cell like Shopify's cart: struck original over the discounted price (or FREE).
  function reviewLinePrice(rawC, discC) {
    if (stayFreeC() && discC < rawC) return '<span class="li-was">' + money(rawC) + '</span>' + (discC <= 0 ? '<b class="li-free">FREE</b>' : money(discC));
    return money(rawC);
  }
  function discTag(code, amt) { return '<span class="li-tag">🏷️ ' + code + ' −' + money(amt) + '</span>'; }
  function renderReview() {
    renderPromo();
    // Line items mirror Shopify's cart: struck original → discounted price, with the code that applied.
    var t = totals(), v = variant();
    var gw = t.q + ' ' + (t.q > 1 ? 'guests' : 'guest');
    var rawTicket = v.priceCents * t.q;
    var commTicket = (communityTicketOn() && COMMUNITY_CENTS > 0) ? COMMUNITY_CENTS * t.q : rawTicket;
    var ticketSub = (v.sub || 'Festival pass') + ' · ' + gw + (communityTicketOn() && commTicket < rawTicket ? discTag(CART.discount, rawTicket - commTicket) : '');
    var lines = HAS.tickets ? li(SHOP.ticketImage, SHOP.ticketTitle + ' · ' + v.title, ticketSub, reviewLinePrice(rawTicket, commTicket), IC_TICKET) : '';
    var st = stayOpt();
    if (st && st.id !== 'none') {
      var rawStay = stayTotalCents(st), commStay = (stayFreeC() && st.multi) ? 0 : rawStay;
      var staySub = (st.multi ? (CART.stayQty + ' ' + (CART.stayQty > 1 ? stayUnitWord(st).many : stayUnitWord(st).one) + ' · ' + money(st.priceCents) + ' each') : ((st.cat === 'onsite' ? 'On-site' : 'Off-site') + ' stay · whole week'))
        + (stayFreeC() && commStay < rawStay ? discTag((FREE_STAY ? (AUTO_DISCOUNT || 'FREE') : (companionsFor(CART.discount)[0] || 'SUNRISECAMP')), rawStay - commStay) : '');
      lines += li(st.img, st.title + (st.multi ? ' × ' + CART.stayQty : ''), staySub, reviewLinePrice(rawStay, commStay));
    }
    if (MODE === 'shuttle') {
      var siR = shOpt('in', CART.shIn), soR = shOpt('out', CART.shOut);
      if (siR.variantId) lines += li('', SHOP.shuttle.inTitle, siR.title + ' · ' + t.q + ' × ' + money(siR.priceCents), money(siR.priceCents * t.q), IC_VAN);
      if (soR.variantId) lines += li('', SHOP.shuttle.outTitle, soR.title + ' · ' + t.q + ' × ' + money(soR.priceCents), money(soR.priceCents * t.q), IC_VAN);
    } else if (t.shuttleCents) lines += li('', 'Airport shuttle', 'SKG transfers', money(t.shuttleCents), IC_VAN);
    if (MODE === 'wellness') CART.sessions.forEach(function (l) {
      var s = sessionById(l.sessionId), sl = slotOf(s, l.slotId);
      var when = l.dateISO ? fmtDay(l.dateISO) + ' · ' + (sl ? sl.timeLabel : '') : 'Anytime · redeem at ' + (l.location || 'the tent');
      lines += li(s ? s.img : '', l.productTitle, when + ' · ' + (attendeeName(l) || 'attendee') + (l.qty > 1 ? ' · ' + l.qty + ' × ' + money(l.priceCents) : ''), money(l.priceCents * l.qty), IC_TICKET);
    });
    // Service fee is a fee, not a product — a quiet subline, not a peer line item.
    if (feeApplies()) lines += '<div class="li-fee"><span class="lf-t">Service fee <i>' + money(SHOP.serviceFeeCents) + ' × ' + gw + ' · incl. 19% VAT</i></span><span class="lf-p">' + money(t.feeCents) + '</span></div>';
    byId('omc-sumlines').innerHTML = lines;
    // …totals come from the real Shopify cart (built on entry), so discounts are exact.
    renderTotals();
    // Wellness: refresh availability first — a slot may have been taken while the guest was choosing.
    if (MODE === 'wellness') recheckSessions().then(function (bad) { if (bad.length) dropLines(bad, 'That slot was just taken — pick another time'); else commitCart(); });
    else commitCart();
  }
  // Totals block: real cart if we have it, else the local estimate.
  function renderTotals() {
    var el = byId('omc-sumtotals'); if (!el) return;
    if (committing) {
      el.innerHTML = '<div class="totrow"><span class="l">Updating total…</span><span class="v">…</span></div>';
      return;
    }
    var html = '', fin, sav = 0;
    if (cartData && (cartData.total_discount || 0) > 0) {
      fin = cartData.total_price; sav = cartData.total_discount;              // real Shopify discount (live)
    } else if (communityCodeOn()) {
      fin = computeTotals(false).totalCents - communityDiscountCents(); sav = communityDiscountCents(); // preview
    } else {
      fin = cartData ? cartData.total_price : computeTotals(false).totalCents;
    }
    html += '<div class="totrow"><span class="l">Subtotal</span><span class="v">' + money(fin) + '</span></div>';
    html += '<div class="totrow grand"><span class="l">Total</span><span class="v">' + money(fin) + '</span></div>';
    if (sav > 0) html += '<div class="totrow save"><span class="l">🏷️ Total savings</span><span class="v">' + money(sav) + '</span></div>';
    el.innerHTML = html;
  }
  // Build the cart in Shopify (clear → add → note → apply code), then read back real totals.
  function commitCart() {
    if (TYPES[FSTEP] !== 'review') return; // only relevant on the Review step
    if (committing) { commitPending = true; return; } // coalesce concurrent calls
    committing = true; commitPending = false; renderTotals(); updateFoot();
    var notesEl = byId('omc-notes'); CART.notes = notesEl ? notesEl.value : '';
    var items = buildCartItems();
    return Promise.resolve()
      .then(function () { return fetch(ROOT + 'cart/clear.js', { method: 'POST' }); })
      .then(function () {
        if (window.theme && window.theme.cart && window.theme.cart.store && window.theme.cart.store.add) return window.theme.cart.store.add(items);
        return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add failed'); }); });
      })
      .then(function () { if (CART.notes) return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: CART.notes }) }); })
      // Wipe any discount codes left on the cart session from a previous commit/attempt. cart/clear.js
      // above only removes LINE ITEMS, not codes — so without this, codes accumulate across attempts
      // (e.g. a SUNRISE test, then a CARAVANWEEKEND entry, would leave BOTH on the cart and Shopify
      // keeps whichever set is combinable). {discount:''} is the only reliable AJAX clear on this shop
      // (verified: /discount/clear just applies a code literally named "clear"). We then rebuild the
      // exact intended set below (auto-discount → primary → companions), so every commit is clean.
      .then(function () { return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }); })
      // Trusted auto-discount (e.g. volunteer100 → free own tent/caravan): applied unconditionally,
      // no validation, before the guest's own code. Empty on every other flow → no-op there.
      .then(function () { if (AUTO_DISCOUNT) return fetch('/discount/' + encodeURIComponent(AUTO_DISCOUNT) + '?redirect=/cart.json'); })
      .then(function () {
        // Discounts, one /discount/ hop each (combinable codes accumulate on the cart session;
        // the comma form /discount/A,B is treated as ONE unknown code on this shop — never use it).
        // Apply the guest's OWN code first and confirm Shopify actually accepted it, THEN bring in
        // any companion — so an invalid code can never trigger a free-camping companion (SUNRISECAMP).
        var primary = CART.discount;
        if (!primary) return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
        return fetch('/discount/' + encodeURIComponent(primary) + '?redirect=/cart.json')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            // Valid if Shopify accepted it: either the code name shows in the applications, OR it
            // produced a discount. The name check alone fails for Klaviyo UNIQUE codes (their
            // application title is the parent discount name, e.g. "SUNRISE", not "SUNRISE-XHY26").
            // Safe to use total_discount here because the companion isn't applied until AFTER this
            // check, so the discount so far reflects only the guest's own code.
            var ok = (cart.total_discount || 0) > 0
                  || (cart.cart_level_discount_applications || []).some(function (d) { return (d.title || '').toUpperCase() === primary; });
            if (!ok) {
              // Only reject once there's something to discount — a code carried in from an
              // email link shouldn't be wiped before the guest has added a ticket.
              if ((cart.item_count || (cart.items || []).length) > 0) { toast('Code “' + primary + '” isn’t valid'); CART.discount = null; renderPromo(); }
              return cart;
            }
            var comps = companionsFor(primary);   // e.g. any VALID SUNRISE* code → SUNRISECAMP (free camping)
            if (!comps.length) return cart;
            var chain = Promise.resolve();
            comps.forEach(function (c) { chain = chain.then(function () { return fetch('/discount/' + encodeURIComponent(c) + '?redirect=/cart.json'); }); });
            return chain.then(function (r) { return r.json(); });
          });
      })
      .then(function (cart) {
        cartData = cart;
      })
      .catch(function (e) { console.error('[Omana checkout] commit failed:', e); cartData = null; if (MODE === 'wellness') handleAddFailure(e); })
      .then(function () { committing = false; renderTotals(); updateFoot(); if (commitPending) commitCart(); });
  }
  function toggleNotes() { byId('omc-notes-t').classList.toggle('open'); byId('omc-notes-body').classList.toggle('open'); }

  /* ---------- checkout: reuse the store's cart logic ---------- */
  // >>> The line-item schema below is what to verify against a real cart. <<<
  function buildCartItems() {
    var items = [];
    // Per-guest properties (person_${i}_*). In full/ticket flows these ride on the ticket line;
    // in accommodation-only they ride on the stay line (there's no ticket to carry them).
    var props = {};
    if (HAS.guests) CART.guests.forEach(function (g, idx) {
      var i = idx + 1;
      props['person_' + i + '_first_name'] = g.first;
      props['person_' + i + '_last_name'] = g.last;
      props['person_' + i + '_email'] = g.email;
      if (!NAMES_ONLY) {   // shuttle passengers / wellness bookers = name + email only
        props['person_' + i + '_birthdate'] = g.dob;
        props['person_' + i + '_gender'] = g.gender;
        var sin = shOpt('in', g.shuttleIn), sout = shOpt('out', g.shuttleOut);
        if (sin.id !== 'none') props['person_' + i + '_to_festival_shuttle'] = sin.title;
        if (sout.id !== 'none') props['person_' + i + '_from_festival_shuttle'] = sout.title;
      }
    });
    // 1) Festival ticket — one line, qty = guests, with the per-guest properties.
    if (HAS.tickets) items.push({ id: variant().id, quantity: CART.qty, properties: props });
    // Free camping pitch (ticket-only code): one bring-your-own pitch, made free by the code's companion discount.
    if (CART.freePitch && CART.freePitch.variantId) items.push({ id: CART.freePitch.variantId, quantity: 1, properties: { _free_camping: 'true' } });
    // 2) Accommodation — one unit, or N pitches for "own tent" (canbookmultiple).
    //    Carries the guest properties when there's no ticket line to hold them.
    var st = stayOpt();
    if (st && st.id !== 'none' && st.variantId) items.push({ id: st.variantId, quantity: stayUnits(st), properties: HAS.tickets ? undefined : props });
    // Shuttle-only mode: CART-level legs × passengers (no per-guest split).
    if (MODE === 'shuttle') {
      var siM = shOpt('in', CART.shIn), soM = shOpt('out', CART.shOut);
      props._shuttle = 'true';   // carry the passenger names + emails onto each shuttle leg (manifest)
      if (siM.variantId) items.push({ id: siM.variantId, quantity: CART.qty, properties: props });
      if (soM.variantId) items.push({ id: soM.variantId, quantity: CART.qty, properties: props });
    }
    // Wellness: one line per booked slot; attendee + booker ride along for the facilitator's list.
    if (MODE === 'wellness') { var bk = CART.guests[0] || {};
      CART.sessions.forEach(function (l) {
        items.push({ id: l.variantId, quantity: l.qty, properties: { attendee_name: attendeeName(l) || bookerName(),
          session_time: l.dateISO ? l.slotTitle : 'Anytime — redeem at the tent', location: l.location || '',
          booked_by: bookerName(), booked_by_email: bk.email || '', _wellness: 'true' } });
      });
    }
    // 3) Shuttle — explicit line items per guest per direction
    if (HAS.guests) CART.guests.forEach(function (g, idx) {
      var sin = shOpt('in', g.shuttleIn), sout = shOpt('out', g.shuttleOut);
      if (sin.variantId) items.push({ id: sin.variantId, quantity: 1, properties: { _shuttle: 'true', person: String(idx + 1) } });
      if (sout.variantId) items.push({ id: sout.variantId, quantity: 1, properties: { _shuttle: 'true', person: String(idx + 1) } });
    });
    // 4) Service fee — €20 per guest, in every flow (incl. accommodation-only). Added explicitly because
    //    the theme's cart.fees module isn't loaded on this custom page. Flagged _service_fee:'true'.
    if (feeApplies() && DATA.serviceFeeVariantId) items.push({ id: DATA.serviceFeeVariantId, quantity: CART.qty, properties: { _service_fee: 'true' } });
    return items;
  }

  function checkout() {
    byId('omc-oh-tot').textContent = money(cartData ? cartData.total_price : totals().totalCents);
    byId('omc-handoff').classList.add('show');
    // The cart was built on the Review step (commitCart), and any discount code is already
    // applied to the cart session — so /checkout carries it automatically. If for some reason
    // the cart isn't built yet, build it now, then hand off.
    var ready = (cartData && !committing) ? Promise.resolve() : commitCart();
    return Promise.resolve(ready)
      .then(function () { window.location.href = ROOT + 'checkout'; })
      .catch(function (err) { console.error('[Omana checkout]', err); byId('omc-handoff').classList.remove('show'); toast('Something went wrong — please try again'); });
  }

  /* ---------- shell markup ---------- */
  function shell() {
    var stepper = TYPES.map(function (t, i) {
      return '<div class="stp' + (i === 0 ? ' cur' : '') + '"><div class="num">' + (i + 1) + '</div><div class="sl">' + (t === 'guests' ? guestsLabel() : TYPE_LBL[t]) + '</div></div>' +
        (i < TYPES.length - 1 ? '<div class="bar"></div>' : '');
    }).join('');
    var ticketsSub = MODE === 'full' ? 'One pass per guest · choose your ticket below, then add your stay.' : 'One pass per guest · choose your ticket below.';
    var staySub = MODE === 'stay' ? 'Choose where you\'ll stay for the festival week.' : 'Add a place to stay for the week — or continue without.';
    return '' +
      '<div class="flow-card">' +
      '<div class="flow-top"><div class="flow-nav">' +
      '<button class="flow-back" id="omc-back" onclick="OMC.back()" aria-label="Back">‹</button>' +
      '<div class="flow-ttl" id="omc-ttl">Get tickets</div>' +
      '<button class="flow-back" onclick="OMC.close()" aria-label="Close">✕</button></div>' +
      '<div class="steps" id="omc-steps">' + stepper + '</div></div>' +
      '<div class="flow-main">' +
      '<div class="flow-body" id="omc-body">' +
      '<div class="fstep" data-type="tickets"><div class="fs-h">Secure your pass</div><div class="fs-sub" id="omc-tksub">' + ticketsSub + '</div><div id="omc-ticketlist" style="margin-top:18px"></div><div id="omc-ladder"></div></div>' +
      '<div class="fstep" data-type="stay"><div class="fs-h">Where will you stay?</div><div class="fs-sub">' + staySub + '</div><div id="omc-stayqty"></div><div id="omc-stay-selected"></div>' +
      '<div class="seg"><button class="seg-b on" id="omc-seg-onsite" onclick="OMC.stayCat(\'onsite\')">On site<span class="cnt">Omana Camp</span></button><button class="seg-b" id="omc-seg-offsite" onclick="OMC.stayCat(\'offsite\')">Off site<span class="cnt">Hotels &amp; more</span></button></div>' +
      '<div class="segcap" id="omc-segcap"></div><div id="omc-staylist"></div><div id="omc-stayskip"></div></div>' +
      '<div class="fstep" data-type="guests"><div class="fs-h">' + (MODE === 'shuttle' ? 'Passenger names' : MODE === 'wellness' ? 'Your details' : 'Guest information') + '</div><div class="fs-sub">' + (MODE === 'shuttle' ? 'Who’s riding? We’ll add these to the driver’s list.' : MODE === 'wellness' ? 'We’ll send your booking confirmation here. Then tell us who’s attending each session.' : 'Enter details for each guest. Names must match photo ID at the gate.') + '</div><div id="omc-guestlist"></div><div id="omc-wl-attendees"></div></div>' +
      '<div class="fstep" data-type="shuttle"><div class="fs-h">Book your transfer</div><div class="fs-sub">Shared rides between SKG Airport (Thessaloniki) and the festival — pick your times.</div>' +
      '<div id="omc-shuttle-pax" style="margin-top:16px"></div>' +
      '<div class="fgroup-t" style="margin-top:22px">To the festival · ' + esc(SHOP.shuttle.inTitle) + '</div><div id="omc-shuttle-in"></div>' +
      '<div class="fgroup-t" style="margin-top:22px">From the festival · ' + esc(SHOP.shuttle.outTitle) + '</div><div id="omc-shuttle-out"></div></div>' +
      '<div class="fstep" data-type="wellness"><div class="fs-h">Wellness &amp; workshops</div><div class="fs-sub">1:1 sessions, ceremonies and workshops across the festival week — pick a session, then a day and time.</div>' +
      '<div id="omc-wl-bar" style="margin-top:16px"></div><div class="fgroup-t">Sessions</div><div id="omc-wl-list"></div><div id="omc-wl-anytime"></div></div>' +
      '<div class="fstep" data-type="review"><div class="fs-h">Review your order</div><div class="fs-sub">One last look before secure payment.</div>' +
      '<div class="sumcard" id="omc-sumlines" style="margin-top:16px"></div>' +
      '<div class="fgroup-t">Discount code</div><div id="omc-promo"></div>' +
      '<button class="notes-t" id="omc-notes-t" onclick="OMC.toggleNotes()"><span>Add order notes</span><span class="p">+</span></button>' +
      '<div class="notes-body" id="omc-notes-body"><textarea id="omc-notes" placeholder="Anything we should know? (dietary needs, arrival time…)"></textarea></div>' +
      '<div class="sumcard" id="omc-sumtotals" style="margin-top:14px"></div>' +
      '<div class="fs-sub" style="text-align:center;margin-top:14px">Tax included · optional trip protection added at secure checkout.</div></div>' +
      '</div>' +
      '<aside class="flow-side" id="omc-side">' +
      '<div class="side-h">Order summary</div>' +
      '<div class="side-lines" id="omc-side-lines"></div>' +
      '<div class="side-tot" id="omc-side-tot"></div>' +
      '<button class="cta" id="omc-side-cta" onclick="OMC.next()">Continue</button>' +
      '<div class="side-trust">Tax included · optional trip protection at secure checkout</div>' +
      '</aside>' +
      '</div>' +
      '<div class="flow-foot"><div class="ft-tot"><div class="fl">Total</div><div class="fv" id="omc-foottot">€0</div><div class="ft-fee" id="omc-footfee"></div></div>' +
      '<button class="cta" id="omc-cta" onclick="OMC.next()">Continue</button></div>' +
      '</div>' +
      '<div class="sheet-overlay" id="omc-stay-overlay" onclick="OMC.closeStay(event)"><div class="sheet" id="omc-staysheet"></div></div>' +
      '<div class="sheet-overlay" id="omc-wl-overlay" onclick="OMC.closeSession(event)"><div class="sheet wlsheet" id="omc-wlsheet"></div></div>' +
      '<div class="picker" id="omc-picker" onclick="OMC.closePicker(event)"><div class="pk"><div class="grab"></div><div class="pk-h" id="omc-pk-title">Choose an option</div><div id="omc-pk-opts"></div></div></div>' +
      '<div class="handoff" id="omc-handoff"><div class="lk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg></div><h3>Taking you to secure checkout</h3><p>Your order is being handed to Shopify’s encrypted checkout to complete payment.</p><div class="oh-tot" id="omc-oh-tot">€0</div><div class="spin"></div></div>' +
      '<div class="omc-toast" id="omc-toast"></div>';
  }

  /* ---------- expose + init ---------- */
  function galNav(e, dir) {
    if (e && e.stopPropagation) e.stopPropagation();
    clearInterval(galTimer); galTimer = null;            // manual nav cancels auto-advance
    var g = byId('omc-sgal'); if (!g || !g.children.length) return;
    var w = g.clientWidth, n = g.children.length;
    var to = (Math.round(g.scrollLeft / w) + dir + n) % n;
    g.scrollTo ? g.scrollTo({ left: to * w, behavior: 'smooth' }) : (g.scrollLeft = to * w);
  }
  window.OMC = {
    next: flowNext, back: flowBack, close: closeFlow, galNav: galNav,
    pickTicket: pickTicket, qty: setQty, togglePhases: togglePhases,
    stayCat: setStayCat, openStay: openStayDetail, closeStay: closeStayDetail, selectStay: selectStay, setStayQty: setStayQty, pickShuttle: pickShuttle,
    toggleGuest: toggleGuest, setGuest: setGuest, key: fieldKey,
    openPicker: openPicker, choosePicker: choosePicker, closePicker: closePicker,
    applyPromo: applyPromo, removePromo: removePromo, toggleNotes: toggleNotes,
    openSession: openSession, closeSession: closeSession, pickDay: pickDay, pickSlot: pickSlot, removeSession: removeSession, setSessionQty: setSessionQty, setAnytimeQty: setAnytimeQty, setAttendee: setAttendee
  };

  root.innerHTML = shell();
  root.removeAttribute('data-loading');
  root.setAttribute('data-mode', MODE);
  history.replaceState({ omc: 0 }, '', location.pathname + location.search); // keep ?view= param
  // Pre-apply a discount code passed in via the URL (e.g. a Klaviyo email button →
  // …?code=SUNRISE-AB12). It's held on the cart and validated at the Review step, where
  // it applies together with its companion (SUNRISECAMP) — so the guest never copy/pastes.
  (function () {
    var m = /[?&](?:code|discount)=([^&#]+)/i.exec(location.search);
    if (m && m[1]) { CART.discount = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().toUpperCase(); CART.freePitch = freePitchFor(CART.discount); }
  })();
  syncGuests();
  if (HAS.tickets) renderTickets();
  goStep(0);
})();
